import { message } from "antd"
import {
    INPUT_IMAGE_TYPE,
    GENERATE_MODE,
    SEGMENT_ALGO_TYPE,
    IMAGE_TYPE,
    CLOTH_TYPE,
    TRYON_CLOTH_TYPE,
    CUSTOM_BKG_MODE,
    RESOLUTION_RATIO,
    RESOURCE_PARAMS,
    RESOURCE_TYPE,
    COMMODITY_SCENE_MODE,
    UPLOAD_SOURCE,
    RESOLUTION_ALIGN,
    CLOTH_COLOR_TYPE,
    POSE_FANTASY_MODE,
    VIDEO_ORIENTATION,
    RELIGHT_MODE
} from "./CONST"
import API, { commonApiInvoker } from '@api/api.js';
import Utils from "./utils";
import UtilsAlgo from "./utilsAlgo"
import PSAIModal from "@PSAIComponents/PSAIModal"
import eventBus from '@utils/eventBus';

// 比较文件名
const compareFilenames = (urla, urlb) => {
    // 从URL中提取文件名
    const extractFilename = (url) => {
        if (!url) return '';
        // 移除查询参数和哈希
        const withoutQuery = url.split('?')[0].split('#')[0];
        // 获取最后一个斜杠后的部分
        const parts = withoutQuery.split('/');
        return parts[parts.length - 1] || '';
    }
    const file1 = extractFilename(urla);
    const file2 = extractFilename(urlb);
    return file1 == file2
}

// 生成按钮是否禁用
export const generateDisabled = (imageType, data) => {
    const {
        currentInputType,
        inputImage,
        mainInputImage,
        currentClothColorType,
        topInputImage,
        bottomInputImage,
        no1MultiAngleImage,
        no2MultiAngleImage,
        tryonModelKeyList,
        poseTryonKeyList,
        glassesTryonKeyList,
        necklaceTryonKeyList,
        simTryonKeyList,
        modelKeyList,
        sceneKeyList,
        shoesKeyList,
        videoKeyList,
        colorKeyList,
        clothColorKeyList,
        inputImageTransform,
        currentPoseFantasyMode,
        prompt,
        prompts,
        materialInputImage,
        matchImages,
        refImages,
        smartDetailMode,
        smartDetailImageList,
        smartDetailProductInfo,
        smartDetailCustomItemList,
        smartDetailClarity,
        smartDetailRatio,
        smartDetailPlatform,
        smartDetailLang,
        smartDetailDetailPageNum,
    } = data
    if (imageType == IMAGE_TYPE.CLOTHES) {
        const inputValid = (currentInputType == INPUT_IMAGE_TYPE.SINGLE && !!inputImage) ||
            (currentInputType == INPUT_IMAGE_TYPE.MULTI && !!topInputImage && !!bottomInputImage)
        const resourceValid = tryonModelKeyList.length > 0
        return !(inputValid && resourceValid)
    } else if (imageType == IMAGE_TYPE.POSE_TRYON && currentPoseFantasyMode == POSE_FANTASY_MODE.REFERENCEMODE) {
        const inputValid = !!inputImage
        const resourceValid = poseTryonKeyList.length > 0
        return !(inputValid && resourceValid)
    } else if (imageType == IMAGE_TYPE.POSE_TRYON && currentPoseFantasyMode == POSE_FANTASY_MODE.FREEMODE) {
        const inputValid = !!inputImage
        const promptsValid = prompts.some(item => item?.trim())
        return !(inputValid && promptsValid)
    } else if (imageType == IMAGE_TYPE.GLASSES_TRYON) {
        const inputValid = !!inputImage
        const resourceValid = glassesTryonKeyList.length > 0
        const foregroundAlphaMask = glassesTryonKeyList[0]?.attr?.foregroundAlphaMask
        return !(inputValid && resourceValid && foregroundAlphaMask)
    } else if (imageType == IMAGE_TYPE.NECKLACE_TRYON) {
        const inputValid = !!inputImage
        const resourceValid = necklaceTryonKeyList.length > 0
        return !(inputValid && resourceValid)
    } else if (imageType == IMAGE_TYPE.SIM_TRYON) {
        const inputValid = !!inputImage
        const resourceValid = simTryonKeyList.length > 0
        // const foregroundAlphaMask = simTryonKeyList[0]?.attr?.foregroundAlphaMask
        return !(inputValid && resourceValid)
    } else if (imageType == IMAGE_TYPE.MODEL || imageType == IMAGE_TYPE.BACKGROUND) {
        const inputValid = !!inputImage
        const resourceValid = modelKeyList.length > 0 || sceneKeyList.length > 0
        return !(inputValid && resourceValid)
    } else if (imageType == IMAGE_TYPE.SHOES) {
        const inputValid = (currentInputType == INPUT_IMAGE_TYPE.SINGLE && !!inputImage) || (currentInputType == INPUT_IMAGE_TYPE.MULTI && !!inputImage && (!!no1MultiAngleImage || !!no2MultiAngleImage))
        const resourceValid = shoesKeyList.length > 0
        return !(inputValid && resourceValid)
    } else if (imageType == IMAGE_TYPE.MODEL_VIDEO) {
        const inputValid = !!inputImage
        const resourceValid = videoKeyList.length > 0
        return !(inputValid && resourceValid)
    } else if (imageType == IMAGE_TYPE.COMMODITY) {
        const inputValid = !!(inputImage && inputImageTransform)
        const resourceValid = sceneKeyList.length > 0
        return !(inputValid && resourceValid)
    } else if (imageType == IMAGE_TYPE.COMMODITYRECOLOR) {
        const inputValid = !!inputImage
        const resourceValid = colorKeyList.length > 0
        return !(inputValid && resourceValid)
    } else if (imageType == IMAGE_TYPE.CLOTH_RECOLOR && currentClothColorType == CLOTH_COLOR_TYPE.CLOTH_RECOLOR) {
        const inputValid = !!inputImage
        const resourceValid = clothColorKeyList.length > 0
        return !(inputValid && resourceValid)
    } else if (imageType == IMAGE_TYPE.CLOTH_RECOLOR && currentClothColorType == CLOTH_COLOR_TYPE.SIM_RECOLOR) {
        const inputValid = !!inputImage
        const inputValid2 = (currentInputType == INPUT_IMAGE_TYPE.SINGLE && !!mainInputImage) ||
            (currentInputType == INPUT_IMAGE_TYPE.MULTI && !!topInputImage && !!bottomInputImage) ||
            (currentInputType == INPUT_IMAGE_TYPE.MATERIAL && !!materialInputImage)
        return !(inputValid && inputValid2)
    } else if (imageType == IMAGE_TYPE.IMAGE_TO_VIDEO) {
        const inputValid = !!inputImage
        const promptValid = prompt?.trim().length > 0
        return !(inputValid && promptValid)
    } else if (imageType == IMAGE_TYPE.CREATIVE_IMAGE_GEN) {
        const inputValid = (refImages?.length || matchImages?.length || 0) > 0
        const promptValid = prompt?.trim().length > 0
        return !(inputValid || promptValid)
    } else if (imageType == IMAGE_TYPE.FUSION_WEAR) {
        return false
    } else if (imageType == IMAGE_TYPE.GRASS_PLANT) {
        const inputValid = !!inputImage
        return !inputValid
    } else if (imageType == IMAGE_TYPE.WATERMARK_REMOVE) {
        const inputValid = !!inputImage
        return !inputValid
    }

    return true
}

// 生成参数
const formatInputParams = async (imageType, data) => {
    const getColorMaskOutput = id => UtilsAlgo.getColorMaskOutput(id)
    const getModelColorMaskId = UtilsAlgo.getModelColorMaskId
    const {
        // 输入图/单件服装
        inputImage,
        // 输入图宽度
        inputImageWidth,
        // 输入图高度
        inputImageHeight,
        // 输入图原始mask
        inputImageOriginalMask,
        // 输入图编辑后的mask
        inputImageEditedMask,
        // 输入图分割id
        inputImageMaskId,
        // 输入图多语义分割id
        inputImageMultiSemanticId,
        // 仅AI模特
        inputImageColorMaskId,
        // 仅AI试衣
        inputImageClothType,
        topInputImage,
        // 顶部输入图宽度
        topInputImageWidth,
        // 顶部输入图高度
        topInputImageHeight,
        // 顶部输入图原始mask
        topInputImageOriginalMask,
        topInputImageEditedMask,
        topInputImageMaskId,
        bottomInputImage,
        // 底部输入图宽度
        bottomInputImageWidth,
        // 底部输入图高度
        bottomInputImageHeight,
        // 底部输入图原始mask
        bottomInputImageOriginalMask,
        bottomInputImageEditedMask,
        bottomInputImageMaskId,
        // 仅鞋子上脚
        // 多视角图
        no1MultiAngleImage,
        // 多视角图宽度
        no1MultiAngleImageWidth,
        // 多视角图高度
        no1MultiAngleImageHeight,
        no1MultiAngleImageMaskId,
        // 多视角图原始mask
        no1MultiAngleImageOriginalMask,
        no1MultiAngleImageEditedMask,
        // 多视角图
        no2MultiAngleImage,
        // 多视角图宽度
        no2MultiAngleImageWidth,
        // 多视角图高度
        no2MultiAngleImageHeight,
        no2MultiAngleImageMaskId,
        // 多视角图原始mask
        no2MultiAngleImageOriginalMask,
        no2MultiAngleImageEditedMask,
        // 仅商品
        // 商品自定义场景配置
        refImgConfig,
        // 商品自定义场景强度
        refImgStrength,
        // 商品图输出比例
        outputRatio,
        // 商品图输出宽度
        outputWidth,
        // 商品图输出高度
        outputHeight,
        // 输入图的位置、缩放、尺寸、旋转等信息 (原dragScaleRef.current)
        inputImageTransform,
        // 试衣模特选择
        tryonModelKeyList,
        // 姿势选择
        poseTryonKeyList,
        // 眼镜试戴
        glassesTryonKeyList,
        // 项链试戴
        necklaceTryonKeyList,
        // 同版型试衣
        simTryonKeyList,
        // 模特选择
        modelKeyList,
        // 场景选择
        sceneKeyList,
        // 鞋子选择
        shoesKeyList,
        // 视频选择
        videoKeyList,
        // 商品颜色选择
        colorKeyList,
        // 生成数量
        generateNum,
        imageSize,
        aspectRatio,
        // 生成模式
        generateMode,
        // 模型选择
        modelProvider,
        // 人像皮肤优化
        skinRefine,
        // 人像光影融合
        relight,
        // 光影融合模式
        relightMode,
        // 自定义背景模式 =free 更加自由 =sim 非常相似
        customBkgMode,
        // 模特换背输出图分辨率  input or  bkg
        resolutionAlign,
        // 输入图类型：单件服装/上下搭配 | 单视角图/多视角图
        currentInputType,
        // 资源筛选
        resourceFilter,
        // 服饰换色颜色选择
        clothColorKeyList,
        // 服饰换色类型：自由换色/同款换色
        currentClothColorType,
        mainInputImageClothType, setMainInputImageClothType,
        mainInputImage, setMainInputImage,
        mainInputImageWidth, setMainInputImageWidth,
        mainInputImageHeight, setMainInputImageHeight,
        mainInputImageMaskId, setMainInputImageMaskId,
        mainInputImageOriginalMask, setMainInputImageOriginalMask,
        mainInputImageEditedMask, setMainInputImageEditedMask,
        mainInputImageNpyId, setMainInputImageNpyId,
        // 自由换色上传图是否是真人
        clothReColorIsPerson,
        // 生成视频时长
        duration,
        // 生成视频提示词
        prompt,
        prompts,
        // 人物朝向
        orientation,
        // 姿势裂变两种模式
        currentPoseFantasyMode,
        // 搭配上身搭配图
        matchImages, setMatchImages,
        // 搭配上身模特图
        modelImage, setModelImage,
        // 表情
        emoji, setEmoji,

        materialInputImage,
        materialInputImageWidth,
        materialInputImageHeight,
        materialInputImageClothType,
        smartDetailMode,
        smartDetailImageList,
        smartDetailProductInfo,
        smartDetailCustomItemList,
        smartDetailClarity,
        smartDetailRatio,
        smartDetailPlatform,
        smartDetailLang,
        smartDetailDetailPageNum,
    } = data
    // 执行AI试穿
    const doTryon = async () => {
        let clothType = CLOTH_TYPE.SHIRT
        if (currentInputType == INPUT_IMAGE_TYPE.SINGLE) {
            if (inputImageClothType == TRYON_CLOTH_TYPE.TOP) {
                clothType = CLOTH_TYPE.SHIRT
            } else if (inputImageClothType == TRYON_CLOTH_TYPE.BOTTOM) {
                clothType = CLOTH_TYPE.PANTS
            } else if (inputImageClothType == TRYON_CLOTH_TYPE.DRESS) {
                clothType = CLOTH_TYPE.DRESS
            }
        } else {
            clothType = CLOTH_TYPE.SUIT
        }
        const maskByType = {}
        if (currentInputType == INPUT_IMAGE_TYPE.SINGLE) {
            const image = inputImage
            let algoId = ""
            if (inputImageMaskId) {
                const ids = inputImageMaskId.split(":")
                algoId = ids.length == 1 ? ids[0] : ids[1]
            }
            const binaryMask = (inputImageEditedMask || inputImageOriginalMask)?.binaryMask
            const meta = {
                algoId: inputImageMaskId,
                originalMask: inputImageOriginalMask,
                editedMask: inputImageEditedMask,
                clothType: inputImageClothType,
                width: inputImageWidth,
                height: inputImageHeight,
            }
            maskByType.main = { image, algoId, binaryMask, meta }
        } else {
            if (TRYON_CLOTH_TYPE.TOP) {
                const image = topInputImage
                let algoId = ""
                if (topInputImageMaskId) {
                    const ids = topInputImageMaskId.split(":")
                    algoId = ids.length == 1 ? ids[0] : ids[1]
                }
                const binaryMask = (topInputImageEditedMask || topInputImageOriginalMask)?.binaryMask
                const meta = {
                    algoId: topInputImageMaskId,
                    originalMask: topInputImageOriginalMask,
                    editedMask: topInputImageEditedMask,
                    width: topInputImageWidth,
                    height: topInputImageHeight,
                }
                maskByType.top = { image, algoId, binaryMask, meta }
            }
            if (TRYON_CLOTH_TYPE.BOTTOM) {
                const image = bottomInputImage
                let algoId = ""
                if (bottomInputImageMaskId) {
                    const ids = bottomInputImageMaskId.split(":")
                    algoId = ids.length == 1 ? ids[0] : ids[1]
                }
                const binaryMask = (bottomInputImageEditedMask || bottomInputImageOriginalMask)?.binaryMask
                const meta = {
                    algoId: bottomInputImageMaskId,
                    originalMask: bottomInputImageOriginalMask,
                    editedMask: bottomInputImageEditedMask,
                    width: bottomInputImageWidth,
                    height: bottomInputImageHeight,
                }
                maskByType.bottom = { image, algoId, binaryMask, meta }
            }
        }
        const data = {
            maskByType,
            poseList: tryonModelKeyList,
            modelList: modelKeyList,
            bkgList: sceneKeyList,
            clothType, // 衣服图的cloth_type目前仅与上传的衣服数量有关：0-上装；1-下装；2-上下装；3-裙装；by ligd 20240517
            modelProvider,
            num: generateNum,
            mode: generateMode,
            attr: {
                filter: resourceFilter
            }
        }
        return data
    }
    // 执行AI模特
    const doModel = async () => {
        const image = inputImage
        let algoId = ""
        if (inputImageMaskId) {
            const ids = inputImageMaskId.split(":")
            algoId = ids.length == 1 ? ids[0] : ids[1]
        }
        const colorMask = inputImageColorMaskId ? await getColorMaskOutput(inputImageColorMaskId) :
            await getColorMaskOutput(await getModelColorMaskId(inputImage))
        const binaryMask = inputImageEditedMask?.binaryMask
        const meta = {
            algoId: inputImageMaskId,
            colorAlgoId: inputImageColorMaskId,
            originalMask: inputImageOriginalMask,
            editedMask: inputImageEditedMask,
            width: inputImageWidth,
            height: inputImageHeight,
        }
        const maskByType = {
            main: { image, algoId, colorMask, binaryMask, meta }
        }
        const data = {
            maskByType,
            modelList: modelKeyList,
            bkgList: sceneKeyList,
            num: generateNum,
            emoji,
            skinRefine,
            relight,
            relightMode,
            attr: {
                filter: resourceFilter
            }
        }
        // if (sceneKeyList.find(item => item.custom)) data.customBkgMode = customBkgMode
        if (sceneKeyList.length > 0) data.resolutionAlign = resolutionAlign
        return data
    }
    // 执行鞋子上脚
    const doShoesTryon = async () => {
        const maskByType = {}

        if (Boolean) {
            const image = inputImage
            let algoId = ""
            if (inputImageMaskId) {
                const ids = inputImageMaskId.split(":")
                algoId = ids.length == 1 ? ids[0] : ids[1]
            }
            let binaryMask = (inputImageEditedMask || inputImageOriginalMask)?.binaryMask
            const meta = {
                algoId: inputImageMaskId,
                originalMask: inputImageOriginalMask,
                editedMask: inputImageEditedMask,
                width: inputImageWidth,
                height: inputImageHeight,
            }
            maskByType.main = { image, algoId, binaryMask, meta }
        }
        if (currentInputType != INPUT_IMAGE_TYPE.SINGLE) {
            if (no1MultiAngleImage) {
                const image = no1MultiAngleImage
                let algoId = ""
                if (no1MultiAngleImageMaskId) {
                    const ids = no1MultiAngleImageMaskId.split(":")
                    algoId = ids.length == 1 ? ids[0] : ids[1]
                }
                let binaryMask = (no1MultiAngleImageEditedMask || no1MultiAngleImageOriginalMask)?.binaryMask
                const meta = {
                    algoId: no1MultiAngleImageMaskId,
                    originalMask: no1MultiAngleImageOriginalMask,
                    editedMask: no1MultiAngleImageEditedMask,
                    width: no1MultiAngleImageWidth,
                    height: no1MultiAngleImageHeight,
                }
                maskByType.angle1 = { image, algoId, binaryMask, meta }
            }
            if (no2MultiAngleImage) {
                const image = no2MultiAngleImage
                let algoId = ""
                if (no2MultiAngleImageMaskId) {
                    const ids = no2MultiAngleImageMaskId.split(":")
                    algoId = ids.length == 1 ? ids[0] : ids[1]
                }
                let binaryMask = (no2MultiAngleImageEditedMask || no2MultiAngleImageOriginalMask)?.binaryMask
                const meta = {
                    algoId: no2MultiAngleImageMaskId,
                    originalMask: no2MultiAngleImageOriginalMask,
                    editedMask: no2MultiAngleImageEditedMask,
                    width: no2MultiAngleImageWidth,
                    height: no2MultiAngleImageHeight,
                }
                maskByType.angle2 = { image, algoId, binaryMask, meta }
            }
        }
        const data = {
            maskByType,
            refList: shoesKeyList,
            num: generateNum,
            mode: generateMode,
            attr: {
                filter: resourceFilter
            }
        }
        return data
    }
    // 执行动作模仿
    const doVideoTryon = async () => {
        const maskByType = {}
        const image = inputImage
        const meta = {
            algoId: inputImageMaskId,
            originalMask: inputImageOriginalMask,
            editedMask: inputImageEditedMask,
            width: inputImageWidth,
            height: inputImageHeight,
        }
        maskByType.main = { image, meta }
        const data = {
            maskByType,
            refList: videoKeyList,
            num: generateNum,
            mode: generateMode,
            prompt: prompt,
            orientation: orientation,
            attr: {
                filter: resourceFilter,
                version: 'V3.12.20260122'
            }
        }
        if (videoKeyList?.[0].attr?.duration > 10000 && orientation == VIDEO_ORIENTATION.SRC) {
            message.error("视频时长不能超过10秒")
        } else if (videoKeyList?.[0].attr?.duration > 30000 && orientation == VIDEO_ORIENTATION.REF) {
            message.error("视频时长不能超过10秒")
        }
        return data
    }
    // 执行商品
    const doCommodity = async () => {
        if (!inputImageTransform) throw new Error("参数异常，请重试")
        const image = inputImage
        let algoId = ""
        if (inputImageMaskId) {
            const ids = inputImageMaskId.split(":")
            algoId = ids.length == 1 ? ids[0] : ids[1]
        }
        const binaryMask = (inputImageEditedMask || inputImageOriginalMask)?.binaryMask
        const meta = {
            algoId: inputImageMaskId,
            originalMask: inputImageOriginalMask,
            editedMask: inputImageEditedMask,
            width: inputImageWidth,
            height: inputImageHeight,
        }
        const maskByType = {
            main: { image, algoId, binaryMask, meta }
        }
        const mode = refImgConfig ? refImgConfig.refImgMode : COMMODITY_SCENE_MODE.PRESET
        const data = {
            maskByType,
            bkgList: sceneKeyList,
            imgDict: JSON.stringify([inputImageTransform]),
            canvasWidth: outputWidth,
            canvasHeight: outputHeight,
            // mode,
            num: generateNum,
            mode: generateMode,
            attr: {
                filter: resourceFilter,
                outputRatio: outputRatio,
                outputWidth: outputWidth,
                outputHeight: outputHeight,
                refImgConfig: refImgConfig,
                version: 'V3.8.20251127'
            }
        }
        // if (mode == COMMODITY_SCENE_MODE.SIMILAR_STYLE) { // 相似风格
        //     if (refImgConfig?.refImgPrompt) {
        //         data.pPrompt = refImgConfig?.refImgPrompt
        //     } else {
        //         const res = await API.image2Text({ image_path: refImgConfig.refImg })
        //         if (res.code != 0) throw new Error(res.message)
        //         data.pPrompt = res.data
        //     }
        // }
        // if (mode != COMMODITY_SCENE_MODE.PRESET) data.refStrength = refImgStrength
        return data
    }
    // 执行商品换色
    const doCommodityRecolor = async () => {
        const image = inputImage
        let algoId = ""
        if (inputImageMaskId) {
            const ids = inputImageMaskId.split(":")
            algoId = ids.length == 1 ? ids[0] : ids[1]
        }
        let binaryMask = (inputImageEditedMask || inputImageOriginalMask)?.binaryMask
        const meta = {
            algoId: inputImageMaskId,
            inputImageMultiSemanticId: inputImageMultiSemanticId,
            originalMask: inputImageOriginalMask,
            editedMask: inputImageEditedMask,
            width: inputImageWidth,
            height: inputImageHeight,
        }
        const maskByType = {
            main: { image, algoId, binaryMask, meta }
        }
        const data = {
            maskByType,
            hdMode: generateMode,
            color: colorKeyList[0],
            num: generateNum,
            attr: {
                filter: resourceFilter
            }
        }
        return data
    }
    // 执行服饰复色
    const doClothRecolor = async () => {
        const image = inputImage
        let algoId = ""
        if (inputImageMaskId) {
            const ids = inputImageMaskId.split(":")
            algoId = ids.length == 1 ? ids[0] : ids[1]
        }

        let binaryMask = (inputImageEditedMask || inputImageOriginalMask)?.binaryMask
        const meta = {
            algoId: inputImageMaskId,
            inputImageMultiSemanticId: inputImageMultiSemanticId,
            originalMask: inputImageOriginalMask,
            editedMask: inputImageEditedMask,
            width: inputImageWidth,
            height: inputImageHeight,
        }
        const maskByType = {
            main: { image, algoId, binaryMask, meta }
        }
        const data = {
            maskByType,
            color: clothColorKeyList[0],
            num: generateNum,
            clothType: 0,
            mode: currentClothColorType,
            attr: {
                clothReColorIsPerson: clothReColorIsPerson,
            }
        }
        return data
    }
    // 执行同款换色
    const doSameClothRecolor = async () => {
        let clothType = CLOTH_TYPE.SHIRT
        if (currentInputType == INPUT_IMAGE_TYPE.SINGLE) {
            if (mainInputImageClothType == TRYON_CLOTH_TYPE.TOP) {
                clothType = CLOTH_TYPE.SHIRT
            } else if (mainInputImageClothType == TRYON_CLOTH_TYPE.BOTTOM) {
                clothType = CLOTH_TYPE.PANTS
            } else if (mainInputImageClothType == TRYON_CLOTH_TYPE.DRESS) {
                clothType = CLOTH_TYPE.DRESS
            }
        } else if (currentInputType == INPUT_IMAGE_TYPE.MATERIAL) {
            if (materialInputImageClothType == TRYON_CLOTH_TYPE.TOP) {
                clothType = CLOTH_TYPE.SHIRT
            } else if (materialInputImageClothType == TRYON_CLOTH_TYPE.BOTTOM) {
                clothType = CLOTH_TYPE.PANTS
            } else if (materialInputImageClothType == TRYON_CLOTH_TYPE.DRESS) {
                clothType = CLOTH_TYPE.DRESS
            }
        } else {
            clothType = CLOTH_TYPE.SUIT
        }
        const maskByType = {}
        // 输入图
        const image = inputImage
        let algoId = ""
        if (inputImageMaskId) {
            const ids = inputImageMaskId.split(":")
            algoId = ids.length == 1 ? ids[0] : ids[1]
        }
        const colorMask = inputImageColorMaskId ? await getColorMaskOutput(inputImageColorMaskId) :
            await getColorMaskOutput(await getModelColorMaskId(inputImage))
        const binaryMask = inputImageEditedMask?.binaryMask || '' // 用户不编辑就不要用inputImageOriginalMask
        const meta = {
            algoId: inputImageMaskId,
            originalMask: inputImageOriginalMask,
            editedMask: inputImageEditedMask,
            width: inputImageWidth,
            height: inputImageHeight,
        }
        maskByType.main = { image, algoId, colorMask, binaryMask, meta }

        // 参考图
        if (currentInputType == INPUT_IMAGE_TYPE.SINGLE) {
            const image = mainInputImage
            let algoId = ""
            if (mainInputImageMaskId) {
                const ids = mainInputImageMaskId.split(":")
                algoId = ids.length == 1 ? ids[0] : ids[1]
            }
            const binaryMask = (mainInputImageEditedMask || mainInputImageOriginalMask)?.binaryMask
            const meta = {
                algoId: mainInputImageMaskId,
                originalMask: mainInputImageOriginalMask,
                editedMask: mainInputImageEditedMask,
                width: mainInputImageWidth,
                height: mainInputImageHeight,
            }
            maskByType.inputCloth = { image, algoId, binaryMask, meta }
        } else if (currentInputType == INPUT_IMAGE_TYPE.MATERIAL) {
            const image = materialInputImage
            const meta = {
                width: materialInputImageWidth,
                height: materialInputImageHeight,
            }
            maskByType.inputCloth = { image, meta }
        } else {
            if (TRYON_CLOTH_TYPE.TOP) {
                const image = topInputImage
                let algoId = ""
                if (topInputImageMaskId) {
                    const ids = topInputImageMaskId.split(":")
                    algoId = ids.length == 1 ? ids[0] : ids[1]
                }
                const binaryMask = (topInputImageEditedMask || topInputImageOriginalMask)?.binaryMask
                const meta = {
                    algoId: topInputImageMaskId,
                    originalMask: topInputImageOriginalMask,
                    editedMask: topInputImageEditedMask,
                    width: topInputImageWidth,
                    height: topInputImageHeight,
                }
                maskByType.topCloth = { image, algoId, binaryMask, meta }
            }
            if (TRYON_CLOTH_TYPE.BOTTOM) {
                const image = bottomInputImage
                let algoId = ""
                if (bottomInputImageMaskId) {
                    const ids = bottomInputImageMaskId.split(":")
                    algoId = ids.length == 1 ? ids[0] : ids[1]
                }
                const binaryMask = (bottomInputImageEditedMask || bottomInputImageOriginalMask)?.binaryMask
                const meta = {
                    algoId: bottomInputImageMaskId,
                    originalMask: bottomInputImageOriginalMask,
                    editedMask: bottomInputImageEditedMask,
                    width: bottomInputImageWidth,
                    height: bottomInputImageHeight,
                }
                maskByType.bottomCloth = { image, algoId, binaryMask, meta }
            }
        }
        const data = {
            maskByType,
            clothType: clothType,
            num: generateNum,
            mode: currentInputType == INPUT_IMAGE_TYPE.MATERIAL ? INPUT_IMAGE_TYPE.MATERIAL : currentClothColorType,
            attr: {}
        }
        return data
    }
    // 执行姿势裂变
    const doPoseTryon = async () => {
        const maskByType = {}
        const image = inputImage
        let algoId = ""
        // if (inputImageMaskId) {
        //     const ids = inputImageMaskId.split(":")
        //     algoId = ids.length == 1 ? ids[0] : ids[1]
        // }
        // const binaryMask = (inputImageEditedMask || inputImageOriginalMask)?.binaryMask
        const meta = {
            // algoId: inputImageMaskId,
            // originalMask: inputImageOriginalMask,
            // editedMask: inputImageEditedMask,
            // clothType: inputImageClothType,
            width: inputImageWidth,
            height: inputImageHeight,
        }
        maskByType.main = {
            image,
            algoId,
            // binaryMask, 
            meta
        }

        const data = {
            maskByType,
            refList: poseTryonKeyList,
            num: generateNum,
            mode: currentPoseFantasyMode,
            prompt: prompt,
            prompts: prompts,
            hdMode: generateMode,
            modelProvider,
            attr: {
                filter: resourceFilter
            }
        }
        return data
    }
    // 执行眼镜试戴
    const doGlassesTryon = async () => {
        const maskByType = {}

        if (Boolean) {
            const image = inputImage
            let algoId = ""
            if (inputImageMaskId) {
                const ids = inputImageMaskId.split(":")
                algoId = ids.length == 1 ? ids[0] : ids[1]
            }
            let binaryMask = (inputImageEditedMask || inputImageOriginalMask)?.binaryMask
            const meta = {
                algoId: inputImageMaskId,
                originalMask: inputImageOriginalMask,
                editedMask: inputImageEditedMask,
                width: inputImageWidth,
                height: inputImageHeight,
                foregroundAlphaMask: glassesTryonKeyList[0]?.attr?.foregroundAlphaMask
            }
            maskByType.main = { image, algoId, binaryMask, meta }
        }

        const data = {
            maskByType,
            refList: glassesTryonKeyList,
            num: generateNum,
            mode: generateMode,
            attr: {
                filter: resourceFilter
            }
        }
        return data
    }
    // 执行项链试戴
    const doNecklaceTryon = async () => {
        const maskByType = {}

        if (Boolean) {
            const image = inputImage
            let algoId = ""
            if (inputImageMaskId) {
                const ids = inputImageMaskId.split(":")
                algoId = ids.length == 1 ? ids[0] : ids[1]
            }
            let binaryMask = (inputImageEditedMask || inputImageOriginalMask)?.binaryMask
            const meta = {
                algoId: inputImageMaskId,
                originalMask: inputImageOriginalMask,
                editedMask: inputImageEditedMask,
                width: inputImageWidth,
                height: inputImageHeight,
            }
            maskByType.main = { image, algoId, binaryMask, meta }
        }

        const data = {
            maskByType,
            refList: necklaceTryonKeyList,
            num: generateNum,
            mode: generateMode,
            attr: {
                filter: resourceFilter
            }
        }
        return data
    }
    // 执行同版型试衣
    const doSimTryon = async () => {
        const maskByType = {}

        if (Boolean) {
            const image = inputImage
            let algoId = ""
            if (inputImageMaskId) {
                const ids = inputImageMaskId.split(":")
                algoId = ids.length == 1 ? ids[0] : ids[1]
            }
            let binaryMask = (inputImageEditedMask || inputImageOriginalMask)?.binaryMask
            const meta = {
                algoId: inputImageMaskId,
                originalMask: inputImageOriginalMask,
                editedMask: inputImageEditedMask,
                width: inputImageWidth,
                height: inputImageHeight,
                foregroundAlphaMask: simTryonKeyList[0]?.attr?.foregroundAlphaMask,
                semanticSimTryonMaskId: simTryonKeyList[0]?.attr?.semanticSimTryonMaskId,
                semanticSimTryonMaskId2: simTryonKeyList[0]?.attr?.semanticSimTryonMaskId2,
            }
            maskByType.main = { image, algoId, binaryMask, meta }
        }
        const clothTypeObj = {
            'top': 0,
            'bottom': 1,
            'dress': 3,
        }

        const clothType = clothTypeObj[inputImageClothType]
        const data = {
            maskByType,
            refList: simTryonKeyList,
            num: generateNum,
            clothType,
            attr: {
                filter: resourceFilter
            }
        }
        return data
    }
    // 执行图生视频
    const doImgToVideo = async () => {
        const maskByType = {}
        const image = inputImage
        const meta = {
            width: inputImageWidth,
            height: inputImageHeight,
        }
        maskByType.main = { image, meta }
        const data = {
            maskByType,
            num: generateNum,
            duration: duration,
            prompt: prompt?.trim(),
            mode: generateMode,
            imageTail: no1MultiAngleImage,
            attr: {
            }
        }
        return data
    }
    // 执行搭配上身
    const doFusionWear = async () => {
        const maskByType = {}

        const data = {
            maskByType,
            mode: generateMode,
            num: generateNum,
            matchImages: matchImages,
            modelImage: modelImage?.[0],
            prompt: prompt?.trim(),
            attr: {}
        }
        return data
    }
    const doCreativeImageGen = async () => {
        const maskByType = {}
        const data = {
            maskByType,
            mode: imageSize,
            num: generateNum,
            refImages: matchImages,
            prompt: prompt?.trim(),
            aspectRatio: aspectRatio || RESOLUTION_RATIO.THREE_FOUR,
            attr: {
                aspectRatio: aspectRatio || RESOLUTION_RATIO.THREE_FOUR,
            }
        }
        return data
    }
    // 执行种草图
    const doGrassPlant = async () => {
        const maskByType = {}
        const image = inputImage
        const meta = {
            width: inputImageWidth,
            height: inputImageHeight,
        }
        maskByType.main = { image, meta }
        const data = {
            maskByType,
            num: generateNum,
            mode: generateMode,
            modelList: modelKeyList,
            bkgList: sceneKeyList,
        }
        return data
    }
    const doSmartDetailPage = async () => {
        const platformMap = {
            taobao: '淘宝',
            tmall: '天猫',
            jd: '京东',
            pdd: '拼多多',
            douyin_shop: '抖音电商',
            vip: '唯品会',
            '1688': '1688',
            xiaohongshu: '小红书',
            amazon: '亚马逊',
            tiktok: 'Tik Tok',
            shopify: 'Shopify',
        }
        const customCategoryMap = {
            poster: 'heroPoster',
            sellingPoint: 'sellingPoints',
            buyerShow: 'buyerShow',
            sceneStyling: 'lifestyleOutfit',
            productInfo: 'productInfo',
            productDetail: 'productDetails',
            sizeChart: 'sizeChart',
            serviceGuarantee: 'shoppingGuarantee',
        }
        const refImages = (smartDetailImageList || [])
            .filter(item => item?.url)
            .map(item => ({
                url: item?.url,
                main: !!item?.main,
            }))
        if (refImages.length > 0 && !refImages.some(item => item.main)) {
            refImages[0].main = true
        }
        const maskByType = {}
        const data = {
            maskByType,
            prompt: smartDetailProductInfo?.trim(),
            num: 1,
            detailPageNum: Number(smartDetailDetailPageNum) || 0,
            attr: {},
            refImages,
            refTemplate: smartDetailMode === 'reference' ? (tryonModelKeyList?.[0] || null) : null,
            customCompList: smartDetailMode === 'detail' ? (smartDetailCustomItemList || [])
                .filter(item => item?.key && item?.key !== 'modelImage')
                .map(item => ({
                    category: customCategoryMap[item.key],
                    num: item?.checked === false ? 0 : (Number(item?.value) || 0),
                }))
                .filter(item => item.category) : null,
            mode: smartDetailClarity === '4k' ? '4K' : '2K',
            aspectRatio: smartDetailRatio || '3:4',
            ecPlatform: platformMap[smartDetailPlatform] || platformMap.tmall,
            lang: smartDetailLang || 'cn',
        }
        return data
    }
    // 执行去水印
    const doWatermarkRemove = async () => {
        const maskByType = {}
        const image = inputImage
        const meta = {
            width: inputImageWidth,
            height: inputImageHeight,
        }
        maskByType.main = { image, meta }
        const data = {
            maskByType,
            num: generateNum,
        }
        return data
    }

    if (imageType == IMAGE_TYPE.CLOTHES) {
        return await doTryon()
    } else if (imageType == IMAGE_TYPE.POSE_TRYON) {
        return await doPoseTryon()
    } else if (imageType == IMAGE_TYPE.GLASSES_TRYON) {
        return await doGlassesTryon()
    } else if (imageType == IMAGE_TYPE.NECKLACE_TRYON) {
        return await doNecklaceTryon()
    } else if (imageType == IMAGE_TYPE.SIM_TRYON) {
        return await doSimTryon()
    } else if (imageType == IMAGE_TYPE.MODEL || imageType == IMAGE_TYPE.BACKGROUND) {
        return await doModel()
    } else if (imageType == IMAGE_TYPE.SHOES) {
        return await doShoesTryon()
    } else if (imageType == IMAGE_TYPE.MODEL_VIDEO) {
        return await doVideoTryon()
    } else if (imageType == IMAGE_TYPE.COMMODITY) {
        return await doCommodity()
    } else if (imageType == IMAGE_TYPE.COMMODITYRECOLOR) {
        return await doCommodityRecolor()
    } else if (imageType == IMAGE_TYPE.CLOTH_RECOLOR && currentClothColorType == CLOTH_COLOR_TYPE.CLOTH_RECOLOR) {
        return await doClothRecolor()
    } else if (imageType == IMAGE_TYPE.CLOTH_RECOLOR && currentClothColorType == CLOTH_COLOR_TYPE.SIM_RECOLOR) {
        return await doSameClothRecolor()
    } else if (imageType == IMAGE_TYPE.IMAGE_TO_VIDEO) {
        return await doImgToVideo()
    } else if (imageType == IMAGE_TYPE.CREATIVE_IMAGE_GEN) {
        return await doCreativeImageGen()
    } else if (imageType == IMAGE_TYPE.FUSION_WEAR) {
        return await doFusionWear()
    } else if (imageType == IMAGE_TYPE.GRASS_PLANT) {
        return await doGrassPlant()
    } else if (imageType == IMAGE_TYPE.SMART_DETAILA_PAGE) {
        return await doSmartDetailPage()
    } else if (imageType == IMAGE_TYPE.WATERMARK_REMOVE) {
        return await doWatermarkRemove()
    }
}

// 处理旧版输入参数
const handleDeprecatedInputParam = async (requestParam, imageType) => {
    console.log('旧版输入参数', requestParam, imageType)
    let taskInfo = {}
    let pathname = ""
    try {
        if (imageType == IMAGE_TYPE.CLOTHES) {
            pathname = "/home/homemain/clothes"
            const input = requestParam.inpaint?.input
            const attr = requestParam.inpaint?.attr
            const mask = requestParam.mask

            const algoId = mask?.algoId
            const topAlgoId = mask?.topAlgoId
            const bottomAlgoId = mask?.bottomAlgoId
            const _inputImage = requestParam.inputImage || ""
            const inputImageArray = _inputImage ? _inputImage.split(',') : []
            if (algoId) {
                taskInfo.inputImage = mask?.editedOutput[0]
                const { width, height } = await Utils.getImageDimensions(taskInfo.inputImage)
                taskInfo.inputImageWidth = width
                taskInfo.inputImageHeight = height
                taskInfo.inputImageMaskId = (!algoId || algoId == "clothes_sample") ?
                    await UtilsAlgo.getClothMaskId(taskInfo.inputImage) :
                    `${SEGMENT_ALGO_TYPE.AICLOTH_MASK}:${algoId}`
                const output = mask?.editedOutput || []
                const output1 = output[1]
                const output2 = output[2]
                const output4 = output[4]
                const editedMask = {
                    foregroundAlphaMask: output1,
                    foregroundMask: output2,
                    binaryMask: output4,
                }
                taskInfo.inputImageOriginalMask = editedMask
                taskInfo.inputImageEditedMask = editedMask
                // 衣物类型
                const _clothType = await UtilsAlgo.getClothType(taskInfo.inputImage)
                let clothType
                if ([CLOTH_TYPE.SHIRT, CLOTH_TYPE.SUIT].includes(_clothType)) clothType = TRYON_CLOTH_TYPE.TOP
                else if (_clothType == CLOTH_TYPE.PANTS) clothType = TRYON_CLOTH_TYPE.BOTTOM
                else if (_clothType == CLOTH_TYPE.DRESS) clothType = TRYON_CLOTH_TYPE.DRESS
                taskInfo.inputImageClothType = clothType
                // 输入图类型
                taskInfo.currentInputType = INPUT_IMAGE_TYPE.SINGLE
            } else if (topAlgoId && bottomAlgoId) {
                if (topAlgoId) {
                    taskInfo.topInputImage = mask?.topEditedOutput[0]
                    // 输入图宽度
                    const { width, height } = await Utils.getImageDimensions(taskInfo.topInputImage)
                    taskInfo.topInputImageWidth = width
                    taskInfo.topInputImageHeight = height
                    // 输入图MaskId
                    taskInfo.topInputImageMaskId = (!topAlgoId || topAlgoId == "clothes_sample") ?
                        await UtilsAlgo.getClothMaskId(taskInfo.topInputImage) :
                        `${SEGMENT_ALGO_TYPE.AICLOTH_MASK}:${topAlgoId}`
                    // 输入图Mask
                    const output = mask?.topEditedOutput || []
                    const output1 = output[1]
                    const output2 = output[2]
                    const output4 = output[4]
                    const editedMask = {
                        foregroundAlphaMask: output1,
                        foregroundMask: output2,
                        binaryMask: output4,
                    }
                    taskInfo.topInputImageOriginalMask = editedMask
                    taskInfo.topInputImageEditedMask = editedMask
                }
                if (bottomAlgoId) {
                    taskInfo.bottomInputImage = mask?.bottomEditedOutput[0]
                    // 输入图宽度
                    const { width, height } = await Utils.getImageDimensions(taskInfo.bottomInputImage)
                    taskInfo.bottomInputImageWidth = width
                    taskInfo.bottomInputImageHeight = height
                    // 输入图MaskId
                    taskInfo.bottomInputImageMaskId = (!bottomAlgoId || bottomAlgoId == "clothes_sample") ?
                        await UtilsAlgo.getClothMaskId(taskInfo.bottomInputImage) :
                        `${SEGMENT_ALGO_TYPE.AICLOTH_MASK}:${bottomAlgoId}`
                    // 输入图Mask
                    const output = mask?.bottomEditedOutput || []
                    const output1 = output[1]
                    const output2 = output[2]
                    const output4 = output[4]
                    const editedMask = {
                        foregroundAlphaMask: output1,
                        foregroundMask: output2,
                        binaryMask: output4,
                    }
                    taskInfo.bottomInputImageOriginalMask = editedMask
                    taskInfo.bottomInputImageEditedMask = editedMask
                }
                // 衣物类型
                taskInfo.inputImageClothType = CLOTH_TYPE.SUIT
                // 输入图类型
                taskInfo.currentInputType = INPUT_IMAGE_TYPE.MULTI
            } else {
                const _algoId = topAlgoId ? topAlgoId : bottomAlgoId
                const inputImage = topAlgoId ?
                    (mask?.topEditedOutput[0]) :
                    (mask?.bottomEditedOutput[0])
                const output = topAlgoId ? mask?.topEditedOutput : mask?.bottomEditedOutput
                const clothType = topAlgoId ? TRYON_CLOTH_TYPE.TOP : TRYON_CLOTH_TYPE.BOTTOM
                // 输入图
                taskInfo.inputImage = inputImage
                // 输入图宽度
                const { width, height } = await Utils.getImageDimensions(taskInfo.inputImage)
                taskInfo.inputImageWidth = width
                taskInfo.inputImageHeight = height
                // 输入图MaskId
                taskInfo.inputImageMaskId = (!_algoId || _algoId == "clothes_sample") ?
                    await UtilsAlgo.getClothMaskId(taskInfo.inputImage) :
                    `${SEGMENT_ALGO_TYPE.AICLOTH_MASK}:${_algoId}`
                // 输入图Mask
                const output1 = output[1]
                const output2 = output[2]
                const output4 = output[4]
                const editedMask = {
                    foregroundAlphaMask: output1,
                    foregroundMask: output2,
                    binaryMask: output4,
                }
                taskInfo.inputImageOriginalMask = editedMask
                taskInfo.inputImageEditedMask = editedMask
                // 衣物类型
                taskInfo.inputImageClothType = clothType
                // 输入图类型
                taskInfo.currentInputType = INPUT_IMAGE_TYPE.SINGLE
            }
            // tryon模特
            try {
                const isSelfDefined = input?.self_defined == 1 ? true : false
                const selfDefinedImg = input?.mote_img
                const tryonModelKey = attr?.pose
                if (isSelfDefined) { // 自定义
                    const params = { ...RESOURCE_PARAMS[RESOURCE_TYPE.TRYON_MODEL] }
                    const res = await API.getCustomResources2({ ...params, pageIndex: 1, pageSize: 50000 })
                    if (res.code != 0) throw new Error(res.message)
                    const list = res.data.items
                    const item = list.find(item => item.attr.tryOnImage == selfDefinedImg)
                    if (!item) throw new Error('自定义模特不存在')
                    taskInfo.tryonModelKeyList = [{
                        key: item.name,
                        title: item.attr.title,
                        url: item.imageUrl,
                        custom: 1 // 0-预设 1-自定义
                    }]
                } else { // 预置
                    const params = { ...RESOURCE_PARAMS[RESOURCE_TYPE.TRYON_MODEL] }
                    const res = await API.getPresetResources2({ ...params, pageIndex: 1, pageSize: 50000 })
                    if (res.code != 0) throw new Error(res.message)
                    const list = res.data.items
                        .filter(item => item.name != "00_default_style")
                        .filter(item => !/_random$/.test(item.name) && item.name != "00_keep")
                        .map(item => ({
                            ...item,
                            subList: item?.subList?.filter(item => !/_random$/.test(item.name))
                        }))
                        .map(item => (item.subList && item.subList.length > 0) ? [item, ...item.subList] : [item]).flat()
                    const item = list.find(item => item.name == tryonModelKey)
                    if (!item) throw new Error('预置模特不存在')
                    taskInfo.tryonModelKeyList = [{
                        key: item.name,
                        title: item.attr.title,
                        url: Utils.addParamsToUrl(item.imageUrl, { version: item.attr.version }),
                        custom: 0 // 0-预设 1-自定义
                    }]
                }
            } catch (err) {
                console.error(err)
                taskInfo.tryonModelKeyList = []
            }
            // 模特
            try {
                const modelKey = attr?.person
                const params = { ...RESOURCE_PARAMS[RESOURCE_TYPE.MODEL] }
                const res = await API.getPresetResources2({ ...params, pageIndex: 1, pageSize: 50000 })
                if (res.code != 0) throw new Error(res.message)
                const list = res.data.items
                    .filter(item => item.name != "00_default_style")
                    .filter(item => !/_random$/.test(item.name) && item.name != "00_keep")
                    .map(item => ({
                        ...item,
                        subList: item?.subList?.filter(item => !/_random$/.test(item.name))
                    }))
                    .map(item => (item.subList && item.subList.length > 0) ? [item, ...item.subList] : [item]).flat()
                const item = list.find(item => item.name == modelKey)
                if (!item) throw new Error('预置模特不存在')
                taskInfo.modelKeyList = [{
                    key: item.name,
                    title: item.attr.title,
                    url: Utils.addParamsToUrl(item.imageUrl, { version: item.attr.version }),
                    custom: 0 // 0-预设 1-自定义
                }]
            } catch (err) {
                console.error(err)
                taskInfo.modelKeyList = []
            }
            // 场景
            try {
                const sceneKey = attr?.background
                const params = { ...RESOURCE_PARAMS[RESOURCE_TYPE.TRYON_SCENE] }
                const res = await API.getPresetResources2({ ...params, pageIndex: 1, pageSize: 50000 })
                if (res.code != 0) throw new Error(res.message)
                const list = res.data.items
                    .filter(item => item.name != "00_default_style")
                    .filter(item => !/_random$/.test(item.name) && item.name != "00_keep")
                    .map(item => ({
                        ...item,
                        subList: item?.subList?.filter(item => !/_random$/.test(item.name))
                    }))
                    .map(item => (item.subList && item.subList.length > 0) ? [item, ...item.subList] : [item]).flat()
                const item = list.find(item => item.name == sceneKey)
                if (!item) throw new Error('预置背景不存在')
                taskInfo.sceneKeyList = [{
                    key: item.name,
                    title: item.attr.title,
                    url: Utils.addParamsToUrl(item.imageUrl, { version: item.attr.version }),
                    custom: 0 // 0-预设 1-自定义
                }]
            } catch (err) {
                console.error(err)
                taskInfo.sceneKeyList = []
            }
            // 生成模式
            taskInfo.generateMode = GENERATE_MODE.STD
            // 生成数量
            taskInfo.generateNum = input.num || 4
            // 商品筛选
            taskInfo.resourceFilter = attr?.modelFilter || {}
        } else if (
            imageType == IMAGE_TYPE.POSE_TRYON ||
            imageType == IMAGE_TYPE.GLASSES_TRYON ||
            imageType == IMAGE_TYPE.NECKLACE_TRYON ||
            imageType == IMAGE_TYPE.FUSION_WEAR) {

        } else if (imageType == IMAGE_TYPE.MODEL || imageType == IMAGE_TYPE.BACKGROUND) {
            pathname = imageType == IMAGE_TYPE.MODEL ? "/home/homemain/model" : "/home/homemain/background"
            const input = requestParam.inpaint?.input
            const attr = requestParam.inpaint?.attr
            const mask = requestParam.mask
            taskInfo.inputImage = mask.editedOutput ? mask.editedOutput[0] : mask.input
            const { width, height } = await Utils.getImageDimensions(requestParam.inputImage)
            taskInfo.inputImageWidth = width
            taskInfo.inputImageHeight = height
            taskInfo.inputImageMaskId = (!mask.algoId || mask.algoId == "model_sample") ?
                await UtilsAlgo.getModelMaskId(taskInfo.inputImage) :
                `${SEGMENT_ALGO_TYPE.AIMODEL_MASK}:${requestParam.mask.algoId}`
            taskInfo.inputImageColorMaskId = await UtilsAlgo.getModelColorMaskId(taskInfo.inputImage)
            const clothMask = await UtilsAlgo.getClothMaskOutput(taskInfo.inputImageMaskId)
            taskInfo.inputImageOriginalMask = clothMask
            // 模特
            try {
                if (input.keepPose) throw new Error("保留容貌")
                const customPerson = attr?.personUrl
                const modelKey = attr?.person
                if (customPerson) {
                    const params = { ...RESOURCE_PARAMS[RESOURCE_TYPE.MODEL] }
                    const res = await API.getCustomResources2({ ...params, pageIndex: 1, pageSize: 50000 })
                    if (res.code != 0) throw new Error(res.message)
                    const list = res.data.items
                    const item = list.find(item => item.name == modelKey)
                    if (!item) throw new Error('自定义模特不存在')
                    taskInfo.modelKeyList = [{
                        key: item.name,
                        title: item.attr.title,
                        url: Utils.addParamsToUrl(item.imageUrl, { version: item.attr.version }),
                        custom: 1 // 0-预设 1-自定义
                    }]
                } else {
                    const params = { ...RESOURCE_PARAMS[RESOURCE_TYPE.MODEL] }
                    const res = await API.getPresetResources2({ ...params, pageIndex: 1, pageSize: 50000 })
                    if (res.code != 0) throw new Error(res.message)
                    const list = res.data.items
                        .filter(item => item.name != "00_default_style")
                        .filter(item => !/_random$/.test(item.name) && item.name != "00_keep")
                        .map(item => ({
                            ...item,
                            subList: item?.subList?.filter(item => !/_random$/.test(item.name))
                        }))
                        .map(item => (item.subList && item.subList.length > 0) ? [item, ...item.subList] : [item]).flat()
                    const item = list.find(item => item.name == modelKey)
                    if (!item) throw new Error('预置模特不存在' + modelKey)
                    taskInfo.modelKeyList = [{
                        key: item.name,
                        title: item.attr.title,
                        url: Utils.addParamsToUrl(item.imageUrl, { version: item.attr.version }),
                        custom: 0 // 0-预设 1-自定义
                    }]
                }
            } catch (err) {
                console.error(err)
                taskInfo.modelKeyList = []
            }
            // 场景
            try {
                if (input.keep_bkg == 3 || input.defined_flag == 1) { // 自定义场景
                    // 自定义参考图
                    const refImg = input?.ref_img || input?.bkg_url
                    const params = { ...RESOURCE_PARAMS[RESOURCE_TYPE.MODEL_SCENE] }
                    const res = await API.getCustomResources2({ ...params, pageIndex: 1, pageSize: 50000 })
                    if (res.code != 0) throw new Error(res.message)
                    const list = res.data.items
                    const item = list.find(item => item.imageUrl == refImg)
                    if (!item) throw new Error('自定义背景不存在')
                    taskInfo.sceneKeyList = [{
                        key: item.name,
                        title: item.attr.title,
                        url: item.imageUrl,
                        custom: 1 // 0-预设 1-自定义
                    }]
                } else {
                    const sceneKey = attr?.background
                    const params = { ...RESOURCE_PARAMS[RESOURCE_TYPE.MODEL_SCENE] }
                    const res = await API.getPresetResources2({ ...params, pageIndex: 1, pageSize: 50000 })
                    if (res.code != 0) throw new Error(res.message)
                    const list = res.data.items
                        .filter(item => item.name != "00_default_style")
                        .filter(item => !/_random$/.test(item.name) && item.name != "00_keep")
                        .map(item => ({
                            ...item,
                            subList: item?.subList?.filter(item => !/_random$/.test(item.name))
                        }))
                        .map(item => (item.subList && item.subList.length > 0) ? [item, ...item.subList] : [item]).flat()
                    const item = list.find(item => item.name == sceneKey)
                    if (!item) throw new Error('预置背景不存在' + sceneKey)
                    taskInfo.sceneKeyList = [{
                        key: item.name,
                        title: item.attr.title,
                        url: Utils.addParamsToUrl(item.imageUrl, { version: item.attr.version }),
                        custom: 0 // 0-预设 1-自定义
                    }]
                }
            } catch (err) {
                console.error(err)
                taskInfo.sceneKeyList = []
            }
            // 商品筛选
            taskInfo.resourceFilter = attr?.modelFilter || {}
            // 颜色筛选
            taskInfo.inputImageColorMaskId = attr?.HSFmultiRes?.id || await UtilsAlgo.getModelColorMaskId(taskInfo.inputImage)
            // 生成模式
            // taskInfo.customBkgMode = CUSTOM_BKG_MODE.FREE
            // 人像皮肤优化
            taskInfo.skinRefine = 0
            // 人像光影融合
            taskInfo.relight = 0
            // 光影融合模式
            taskInfo.relightMode = RELIGHT_MODE.SKIN
            // 模特换背输出图的分辨率
            taskInfo.resolutionAlign = RESOLUTION_ALIGN.BKG
            // 生成数量
            taskInfo.generateNum = input.num || 4
        } else if (imageType == IMAGE_TYPE.SHOES) {
            pathname = "/home/homemain/shoesTryon"
            const input = requestParam.inpaint?.input
            const attr = requestParam.inpaint?.attr
            const mask = requestParam.mask
            // 处理主图和多视角图
            let editedOutput, editedOutput1, editedOutput2
            let inputImage, inputImage1, inputImage2
            if (mask.editedOutput.length > 0 || mask.output.length > 0) {
                if (mask.editedOutput.length > 0) {
                    const output = mask.editedOutput
                    inputImage = output[0]
                    const output1 = output[1]
                    const output2 = output[2]
                    const output4 = output[4]
                    editedOutput = {
                        foregroundAlphaMask: output1,
                        binaryMask: output4,
                        foregroundMask: output2,
                    }
                } else {
                    const output = mask.output
                    inputImage = output[0]
                    const output1 = output[1]
                    const output2 = output[2]
                    const output3 = output[3]
                    editedMask = {
                        foregroundAlphaMask: output1,
                        binaryMask: output2,
                        foregroundMask: output3,
                    }
                }
            }
            if (attr?.editedOutput1?.length > 0) {
                const output = attr?.editedOutput1
                inputImage1 = output[0]
                const output1 = output[1]
                const output2 = output[2]
                const output4 = output[4]
                editedOutput1 = {
                    foregroundAlphaMask: output1,
                    binaryMask: output4,
                    foregroundMask: output2,
                }
            }
            if (attr?.editedOutput2?.length > 0) {
                const output = attr?.editedOutput2
                inputImage2 = output[0]
                const output1 = output[1]
                const output2 = output[2]
                const output4 = output[4]
                editedOutput2 = {
                    foregroundAlphaMask: output1,
                    binaryMask: output4,
                    foregroundMask: output2,
                }
            }
            // 处理各种情况
            let mainEditedOutput, no1EditedOutput, no2EditedOutput
            let mainInputImage, no1InputImage, no2InputImage
            if (editedOutput) {
                mainEditedOutput = editedOutput
                mainInputImage = inputImage
                if (editedOutput1) {
                    no1EditedOutput = editedOutput1
                    no1InputImage = inputImage1
                    if (editedOutput2) {
                        no2EditedOutput = editedOutput2
                        no2InputImage = inputImage2
                    }
                } else {
                    if (editedOutput2) {
                        no1EditedOutput = editedOutput2
                        no1InputImage = inputImage2
                    }
                }
            } else {
                if (editedOutput1) {
                    mainEditedOutput = editedOutput1
                    mainInputImage = inputImage1
                    if (editedOutput2) {
                        no1EditedOutput = editedOutput2
                        no1InputImage = inputImage2
                    }
                } else {
                    if (editedOutput2) {
                        mainEditedOutput = editedOutput2
                        mainInputImage = inputImage2
                    }
                }
            }
            // 主图
            if (!mainEditedOutput) throw new Error("主图不存在")
            else {
                taskInfo.inputImage = mainInputImage
                const { width, height } = await Utils.getImageDimensions(taskInfo.inputImage)
                taskInfo.inputImageWidth = width
                taskInfo.inputImageHeight = height
                taskInfo.inputImageMaskId = await UtilsAlgo.getShoesMaskId(taskInfo.inputImage)
                taskInfo.inputImageOriginalMask = mainEditedOutput
                taskInfo.inputImageEditedMask = mainEditedOutput
            }
            // 多视角1
            if (no1EditedOutput) {
                taskInfo.no1MultiAngleImage = no1InputImage
                const { width, height } = await Utils.getImageDimensions(taskInfo.no1MultiAngleImage)
                taskInfo.no1MultiAngleImageWidth = width
                taskInfo.no1MultiAngleImageHeight = height
                taskInfo.no1MultiAngleImageMaskId = await UtilsAlgo.getShoesMaskId(taskInfo.no1MultiAngleImage)
                taskInfo.no1MultiAngleImageOriginalMask = no1EditedOutput
                taskInfo.no1MultiAngleImageEditedMask = no1EditedOutput
            }
            // 多视角2
            if (no2EditedOutput) {
                taskInfo.no2MultiAngleImage = no2InputImage
                const { width, height } = await Utils.getImageDimensions(taskInfo.no2MultiAngleImage)
                taskInfo.no2MultiAngleImageWidth = width
                taskInfo.no2MultiAngleImageHeight = height
                taskInfo.no2MultiAngleImageMaskId = await UtilsAlgo.getShoesMaskId(taskInfo.no2MultiAngleImage)
                taskInfo.no1MultiAngleImageOriginalMask = no2EditedOutput
                taskInfo.no2MultiAngleImageEditedMask = no2EditedOutput
            }
            // 输入图类型
            if (no1EditedOutput || no2EditedOutput) {
                taskInfo.currentInputType = INPUT_IMAGE_TYPE.MULTI
            } else {
                taskInfo.currentInputType = INPUT_IMAGE_TYPE.SINGLE
            }
            // 参考图
            try {
                const shoesStyleList = attr?.shoesStyleList || []
                const customShoesStyleList = attr?.customShoesStyleList || []
                const params = { ...RESOURCE_PARAMS[RESOURCE_TYPE.TRYON_SHOES] }
                const [customRes, presetRes] = await Promise.all([
                    API.getCustomResources2({ ...params, pageIndex: 1, pageSize: 50000 }),
                    API.getPresetResources2({ ...params, pageIndex: 1, pageSize: 50000 }),
                ])
                if (customRes.code != 0 || presetRes.code != 0) throw new Error(customRes.message || presetRes.message)
                const customList = customRes.data.items
                const presetList = presetRes.data.items
                    .filter(item => item.name != "00_default_style")
                    .filter(item => !/_random$/.test(item.name) && item.name != "00_keep")
                    .map(item => ({
                        ...item,
                        subList: item?.subList?.filter(item => !/_random$/.test(item.name))
                    }))
                    .map(item => (item.subList && item.subList.length > 0) ? [item, ...item.subList] : [item]).flat()
                const shoesKeyList = []
                for (let item of customShoesStyleList) {
                    const find = customList.find(customItem => customItem.name == item.name)
                    if (find) {
                        shoesKeyList.push({
                            key: find.name,
                            title: find.attr.title,
                            url: find.imageUrl,
                            custom: 1 // 0-预设 1-自定义
                        })
                    }
                }
                for (let item of shoesStyleList) {
                    const find = presetList.find(presetItem => presetItem.name == item.name)
                    if (find) {
                        shoesKeyList.push({
                            key: find.name,
                            title: find.attr.title,
                            url: Utils.addParamsToUrl(find.imageUrl, { version: find.attr.version }),
                            custom: 0 // 0-预设 1-自定义
                        })
                    }
                }
                taskInfo.shoesKeyList = shoesKeyList
            } catch (err) {
                console.error(err)
                taskInfo.shoesKeyList = []
            }
            // 生成模式
            taskInfo.generateMode = GENERATE_MODE.STD
            // 商品筛选
            taskInfo.resourceFilter = attr?.shoesFilter || {}
            // 生成数量
            taskInfo.generateNum = input.num || 4
        } else if (imageType == IMAGE_TYPE.MODEL_VIDEO) {
            pathname = "/home/homemain/model_video"
            const input = requestParam.inpaint?.input
            const attr = requestParam.inpaint?.attr
            const mask = requestParam.mask
            // 输入图
            taskInfo.inputImage = requestParam.inputImage
            const { width, height } = await Utils.getImageDimensions(taskInfo.inputImage)
            taskInfo.inputImageWidth = width
            taskInfo.inputImageHeight = height
            // 视频
            try {
                const videoKey = input?.ctl_videoKey
                const params = { ...RESOURCE_PARAMS[RESOURCE_TYPE.VIDEO_MODEL] }
                let item, isCustom
                if (Boolean) {
                    const res = await API.getPresetResources2({ ...params, pageIndex: 1, pageSize: 50000 })
                    if (res.code != 0) throw new Error(res.message)
                    const list = res.data.items
                        .filter(item => item.name != "00_default_style")
                        .filter(item => !/_random$/.test(item.name) && item.name != "00_keep")
                        .map(item => ({
                            ...item,
                            subList: item?.subList?.filter(item => !/_random$/.test(item.name))
                        }))
                        .map(item => (item.subList && item.subList.length > 0) ? [item, ...item.subList] : [item]).flat()
                    item = list.find(item => item.name == videoKey)
                }
                if (item) {
                    isCustom = false
                } else {
                    const res = await API.getCustomResources2({ ...params, pageIndex: 1, pageSize: 50000 })
                    if (res.code != 0) throw new Error(res.message)
                    const list = res.data.items
                    item = list.find(item => item.name == videoKey)
                    isCustom = true
                }
                if (!item) throw new Error('自定义背景不存在')
                taskInfo.videoKeyList = [{
                    key: item.name,
                    title: item.attr.title,
                    url: Utils.addParamsToUrl(item.imageUrl, { version: item.attr.version }),
                    custom: isCustom ? 1 : 0 // 0-预设 1-自定义
                }]
            } catch (err) {
                console.error(err)
                taskInfo.videoKeyList = []
            }
            // 视频筛选
            taskInfo.resourceFilter = {}
            // 生成数量
            taskInfo.generateNum = input.num || 1
        } else if (imageType == IMAGE_TYPE.COMMODITY) {
            pathname = "/home/homemain/commodity"
            const input = requestParam.inpaint?.input
            const attr = requestParam.inpaint?.attr
            const mask = requestParam.mask
            // 输入图
            taskInfo.inputImage = mask.editedOutput[0]
            const { width, height } = await Utils.getImageDimensions(taskInfo.inputImage)
            taskInfo.inputImageWidth = width
            taskInfo.inputImageHeight = height
            taskInfo.inputImageMaskId = (!mask.algoId || mask.algoId == "commodity_sample") ?
                await UtilsAlgo.getGoodsMaskId(taskInfo.inputImage) :
                `${SEGMENT_ALGO_TYPE.AIGOODS_MASK}:${mask.algoId}`
            const output = mask.editedOutput
            const output1 = output[1]
            const output2 = output[2]
            const output3 = output[3]
            const output4 = output[4]
            const editedMask = {
                foregroundAlphaMask: output1,
                foregroundMask: output2,
                trimmedMask: output3,
                binaryMask: output4,
            }
            taskInfo.inputImageOriginalMask = editedMask
            taskInfo.inputImageEditedMask = editedMask
            // 场景
            try {
                const isCustomScene = (input.keep_bkg == 3 || input?.defined_flag == 1) && (input?.ref_img || input?.bkg_url)
                const params = { ...RESOURCE_PARAMS[RESOURCE_TYPE.COMMODITY_SCENE] }
                if (isCustomScene) {
                    const refImg = input?.ref_img || input?.bkg_url
                    const res = await API.getCustomResources2({ ...params, pageIndex: 1, pageSize: 50000 })
                    if (res.code != 0) throw new Error(res.message)
                    const list = res.data.items
                    const item = list.find(item => item.imageUrl == refImg)
                    if (!item) throw new Error('自定义背景不存在' + refImg)
                    taskInfo.sceneKeyList = [{
                        key: item.name,
                        title: item.attr.title,
                        url: item.imageUrl,
                        custom: 1 // 0-预设 1-自定义
                    }]
                    // 商品自定义场景配置
                    taskInfo.refImgConfig = {
                        refImg: item.imageUrl,
                        refImgMask: item.attr.mask || null,
                        refImgProcessed: item.attr.imgProcessed || null,
                        refImgSize: {
                            width: item.attr.width,
                            height: item.attr.height
                        },
                        refImgLocalInfo: item.attr.objectLocationInfo || null,
                        refImgMode: item.attr.version == 3 ? COMMODITY_SCENE_MODE.SAME_STYLE : COMMODITY_SCENE_MODE.SIMILAR_STYLE,
                    }
                } else {
                    const sceneKey = attr?.background
                    const res = await API.getPresetResources2({ ...params, pageIndex: 1, pageSize: 50000 })
                    if (res.code != 0) throw new Error(res.message)
                    const list = res.data.items
                        .filter(item => item.name != "00_default_style")
                        .filter(item => !/_random$/.test(item.name) && item.name != "00_keep")
                        .map(item => ({
                            ...item,
                            subList: item?.subList?.filter(item => !/_random$/.test(item.name))
                        }))
                        .map(item => (item.subList && item.subList.length > 0) ? [item, ...item.subList] : [item]).flat()
                    const item = list.find(item => item.name == sceneKey)
                    if (!item) throw new Error('预置背景不存在' + sceneKey)
                    taskInfo.sceneKeyList = [{
                        key: item.name,
                        title: item.attr.title,
                        url: Utils.addParamsToUrl(item.imageUrl, { version: item.attr.version }),
                        custom: 0 // 0-预设 1-自定义
                    }]
                }
            } catch (err) {
                console.error(err)
                taskInfo.sceneKeyList = []
            }
            // 商品自定义场景强度
            let refStrength = 0.5
            let refVersion = input?.refine_version || 2
            const ref_strength = input?.ref_strength || 0
            const ref_prompt_strength = input?.ref_prompt_strength || 0
            if (refVersion == 1 || refVersion == 3) { // 背景合成/拍同款，强度取ref_strength
                refStrength = ref_strength
            } else { // 相似风格，强度取ref_prompt_strength
                refStrength = ref_prompt_strength
            }
            taskInfo.refImgStrength = refStrength
            // 商品图输出比例
            taskInfo.outputRatio = attr?.imgRatio || '1:1'
            // 商品图输出宽度
            taskInfo.outputWidth = input?.canvas_width || 1024
            // 商品图输出高度
            taskInfo.outputHeight = input?.canvas_height || 1024
            // 输入图的位置、缩放、尺寸、旋转等信息 (原dragScaleRef.current)
            taskInfo.inputImageTransform = input?.imgs_dict ? JSON.parse(input?.imgs_dict).find(item => item?.name == "ori") : null
            // 生成数量
            taskInfo.generateNum = input.num || 4
            // 资源筛选
            taskInfo.resourceFilter = attr?.commodityFilter || {}
            // 获取推荐筛选条件
            const filter = await UtilsAlgo.getCommodityRecommendFilter(taskInfo.inputImage, taskInfo.inputImageOriginalMask.binaryMask)
            if (filter) {
                taskInfo.resourceFilter = {
                    ...taskInfo.resourceFilter,
                    recommendCommodityType: filter,
                }
            }
        } else if (imageType == IMAGE_TYPE.COMMODITYRECOLOR) {
            pathname = "/home/homemain/commodityRecolor"
            const input = requestParam.inpaint?.input
            const attr = requestParam.inpaint?.attr
            const mask = requestParam.mask
            // 输入图
            taskInfo.inputImage = requestParam.inputImage
            const { width, height } = await Utils.getImageDimensions(taskInfo.inputImage)
            taskInfo.inputImageWidth = width
            taskInfo.inputImageHeight = height
            taskInfo.inputImageMaskId = await UtilsAlgo.getShoesMaskId(taskInfo.inputImage)
            const isPerson = await personCheck(imageUrl)
            if (isPerson) {
                taskInfo.inputImageMultiSemanticId = await UtilsAlgo.getMultiSemanticId(taskInfo.inputImage)
            } else taskInfo.inputImageMultiSemanticId = null
            const binaryMask = mask.editedOutput?.[0]
            const foregroundAlphaMaskBase64 = await Utils.convertWhiteImageToBlue(binaryMask)
            const blueMaskBase64AfterOpaque = await Utils.setOpaquePixels(foregroundAlphaMaskBase64)
            const foregroundMaskBase64 = await Utils.getForegroundImage(taskInfo.inputImage, blueMaskBase64AfterOpaque)
            const foregroundAlphaMask = await Utils.uploadBase64Image(foregroundAlphaMaskBase64)
            const foregroundMask = await Utils.uploadBase64Image(foregroundMaskBase64)
            const editedMask = {
                foregroundAlphaMask,
                binaryMask,
                foregroundMask,
            }
            taskInfo.inputImageOriginalMask = editedMask
            taskInfo.inputImageEditedMask = editedMask
            taskInfo.colorKeyList = [input.color]
            // taskInfo.resourceFilter
            // 生成数量
            taskInfo.generateNum = input.num || 4
        } else if (imageType == IMAGE_TYPE.CLOTH_RECOLOR) {
        }
    } catch (err) {
        console.error(err)
        taskInfo = null
    }
    if (!taskInfo || !pathname) {
        throw new Error("版本已更新，无法复用之前的选择")
    } else {
        return {
            taskInfo,
            pathname
        }
    }
}

// 处理输入参数（用于再次生成、重新编辑等）
const handleInputParam = async (requestParam, imageType, commidityOldDataRebuild = false) => {
    const taskInfo = {}
    let pathname = ""
    if (imageType == IMAGE_TYPE.CLOTHES) {
        pathname = "/home/homemain/clothes"
        const maskByType = requestParam.maskByType
        // 输入图
        if (maskByType.main) { // 单件服装
            const obj = maskByType.main
            const meta = obj.meta
            taskInfo.inputImage = obj.image
            if (meta.width) {
                taskInfo.inputImageWidth = meta.width
                taskInfo.inputImageHeight = meta.height
            } else {
                const { width, height } = await Utils.getImageDimensions(obj.image)
                taskInfo.inputImageWidth = width
                taskInfo.inputImageHeight = height
            }
            taskInfo.inputImageOriginalMask = meta?.originalMask || null
            taskInfo.inputImageEditedMask = meta?.editedMask || null
            taskInfo.inputImageMaskId = meta?.algoId || null
            taskInfo.inputImageClothType = meta?.clothType || null
            // 输入图类型
            taskInfo.currentInputType = INPUT_IMAGE_TYPE.SINGLE
        } else if (maskByType.top || maskByType.bottom) { // 上下搭配
            if (maskByType.top) {
                const obj = maskByType.top
                const meta = obj.meta
                taskInfo.topInputImage = obj.image
                if (meta.width) {
                    taskInfo.topInputImageWidth = meta.width
                    taskInfo.topInputImageHeight = meta.height
                } else {
                    const { width, height } = await Utils.getImageDimensions(obj.image)
                    taskInfo.topInputImageWidth = width
                    taskInfo.topInputImageHeight = height
                }
                taskInfo.topInputImageOriginalMask = meta?.originalMask || null
                taskInfo.topInputImageEditedMask = meta?.editedMask || null
                taskInfo.topInputImageMaskId = meta?.algoId || null
            }
            if (maskByType.bottom) {
                const obj = maskByType.bottom
                const meta = obj.meta
                taskInfo.bottomInputImage = obj.image
                if (meta.width) {
                    taskInfo.bottomInputImageWidth = meta.width
                    taskInfo.bottomInputImageHeight = meta.height
                } else {
                    const { width, height } = await Utils.getImageDimensions(obj.image)
                    taskInfo.bottomInputImageWidth = width
                    taskInfo.bottomInputImageHeight = height
                }
                taskInfo.bottomInputImageOriginalMask = meta?.originalMask || null
                taskInfo.bottomInputImageEditedMask = meta?.editedMask || null
                taskInfo.bottomInputImageMaskId = meta?.algoId || null
            }
            // 输入图类型
            taskInfo.currentInputType = INPUT_IMAGE_TYPE.MULTI
        }
        // 参考图
        if (requestParam.poseList) taskInfo.tryonModelKeyList = requestParam.poseList
        // 模特
        if (requestParam.modelList) taskInfo.modelKeyList = requestParam.modelList
        // 场景
        if (requestParam.bkgList) taskInfo.sceneKeyList = requestParam.bkgList
        // 生成模式
        taskInfo.generateMode = requestParam.mode
        // 模型选择
        if (requestParam.modelProvider) taskInfo.modelProvider = requestParam.modelProvider
        // 生成数量
        taskInfo.generateNum = requestParam.num
        // 资源筛选
        if (requestParam?.attr?.filter) taskInfo.resourceFilter = requestParam?.attr?.filter
    } else if (imageType == IMAGE_TYPE.POSE_TRYON) {
        pathname = "/home/homemain/poseTryon"
        const maskByType = requestParam.maskByType
        // 输入图
        if (maskByType.main) {
            const obj = maskByType.main
            const meta = obj.meta
            taskInfo.inputImage = obj.image
            if (meta.width) {
                taskInfo.inputImageWidth = meta.width
                taskInfo.inputImageHeight = meta.height
            } else {
                const { width, height } = await Utils.getImageDimensions(obj.image)
                taskInfo.inputImageWidth = width
                taskInfo.inputImageHeight = height
            }
            // taskInfo.inputImageOriginalMask = meta?.originalMask || null
            // taskInfo.inputImageEditedMask = meta?.editedMask || null
            // taskInfo.inputImageMaskId = meta?.algoId || null
            taskInfo.inputImageColorMaskId = meta?.colorAlgoId || await UtilsAlgo.getModelColorMaskId(taskInfo.inputImage)
        }
        // 参考图
        if (requestParam.refList) taskInfo.poseTryonKeyList = requestParam.refList
        // 提示词
        taskInfo.prompts = requestParam.prompt? [requestParam.prompt] : []
        // 姿势裂变模式
        taskInfo.currentPoseFantasyMode = requestParam.mode
        // 生成数量
        taskInfo.generateNum = requestParam.num
        // 生成模式
        if (requestParam.hdMode) taskInfo.generateMode = requestParam.hdMode
        if (requestParam.modelProvider) taskInfo.modelProvider = requestParam.modelProvider
        // 资源筛选
        if (requestParam?.attr?.filter) taskInfo.resourceFilter = requestParam?.attr?.filter

    } else if (imageType == IMAGE_TYPE.GLASSES_TRYON) {
        pathname = "/home/homemain/glassesTryon"
        const maskByType = requestParam.maskByType
        // 输入图
        if (maskByType.main) {
            const obj = maskByType.main
            const meta = obj.meta
            taskInfo.inputImage = obj.image
            if (meta.width) {
                taskInfo.inputImageWidth = meta.width
                taskInfo.inputImageHeight = meta.height
            } else {
                const { width, height } = await Utils.getImageDimensions(obj.image)
                taskInfo.inputImageWidth = width
                taskInfo.inputImageHeight = height
            }
            taskInfo.inputImageOriginalMask = meta?.originalMask || null
            taskInfo.inputImageEditedMask = meta?.editedMask || null
            taskInfo.inputImageMaskId = meta?.algoId || null
            // taskInfo.inputImageColorMaskId = meta?.colorAlgoId || await UtilsAlgo.getModelColorMaskId(taskInfo.inputImage)

            // 参考图
            if (requestParam.refList) {
                taskInfo.glassesTryonKeyList = requestParam.refList.map(item => ({
                    ...item,
                    attr: {
                        foregroundAlphaMask: meta?.foregroundAlphaMask
                    }
                }));
            }
        }

        // 生成数量
        taskInfo.generateNum = requestParam.num
        // 生成模式
        if (requestParam.mode) taskInfo.generateMode = requestParam.mode

    } else if (imageType == IMAGE_TYPE.NECKLACE_TRYON) {
        pathname = "/home/homemain/necklaceTryon"
        const inputImage = requestParam.image || requestParam.inputImage || requestParam.maskByType?.main?.image
        if (inputImage) {
            taskInfo.inputImage = inputImage
            if (requestParam.width && requestParam.height) {
                taskInfo.inputImageWidth = requestParam.width
                taskInfo.inputImageHeight = requestParam.height
            } else if (requestParam.maskByType?.main?.meta?.width) {
                taskInfo.inputImageWidth = requestParam.maskByType.main.meta.width
                taskInfo.inputImageHeight = requestParam.maskByType.main.meta.height
            } else {
                const { width, height } = await Utils.getImageDimensions(inputImage)
                taskInfo.inputImageWidth = width
                taskInfo.inputImageHeight = height
            }
        }

        // 兼容老数据
        if (requestParam.maskByType?.main?.meta) {
            const meta = requestParam.maskByType.main.meta
            taskInfo.inputImageOriginalMask = meta?.originalMask || null
            taskInfo.inputImageEditedMask = meta?.editedMask || null
            taskInfo.inputImageMaskId = meta?.algoId || null
        }

        // 参考图
        if (requestParam.refList) {
            taskInfo.necklaceTryonKeyList = requestParam.refList
        }

        // 生成数量
        taskInfo.generateNum = requestParam.num
        // 生成模式
        if (requestParam.mode) taskInfo.generateMode = requestParam.mode

    } else if (imageType == IMAGE_TYPE.SIM_TRYON) {
        pathname = "/home/homemain/simTryon"
        const maskByType = requestParam.maskByType
        // 输入图
        if (maskByType.main) {
            const obj = maskByType.main
            const meta = obj.meta
            taskInfo.inputImage = obj.image
            if (meta.width) {
                taskInfo.inputImageWidth = meta.width
                taskInfo.inputImageHeight = meta.height
            } else {
                const { width, height } = await Utils.getImageDimensions(obj.image)
                taskInfo.inputImageWidth = width
                taskInfo.inputImageHeight = height
            }
            taskInfo.inputImageOriginalMask = meta?.originalMask || null
            taskInfo.inputImageEditedMask = meta?.editedMask || null
            taskInfo.inputImageMaskId = meta?.algoId || null
            // taskInfo.inputImageColorMaskId = meta?.colorAlgoId || await UtilsAlgo.getModelColorMaskId(taskInfo.inputImage)

            // 参考图
            if (requestParam.refList) {
                taskInfo.simTryonKeyList = requestParam.refList.map(item => ({
                    ...item,
                    attr: {
                        foregroundAlphaMask: meta?.foregroundAlphaMask,
                        semanticSimTryonMaskId: meta?.semanticSimTryonMaskId,
                        semanticSimTryonMaskId2: meta?.semanticSimTryonMaskId2
                    }
                }))
            }
        }
        const clothTypeObj = {
            0: 'top',
            1: 'bottom',
            3: 'dress',
        }
        taskInfo.inputImageClothType = clothTypeObj[requestParam?.clothType]
        // 生成数量
        taskInfo.generateNum = requestParam.num
        // 资源筛选
        if (requestParam?.attr?.filter) taskInfo.resourceFilter = requestParam?.attr?.filter

    } else if (imageType == IMAGE_TYPE.MODEL || imageType == IMAGE_TYPE.BACKGROUND) {
        pathname = imageType == IMAGE_TYPE.MODEL ? "/home/homemain/model" : "/home/homemain/background"
        const maskByType = requestParam.maskByType
        // 输入图
        if (maskByType.main) {
            const obj = maskByType.main
            const meta = obj.meta
            taskInfo.inputImage = obj.image
            if (meta.width) {
                taskInfo.inputImageWidth = meta.width
                taskInfo.inputImageHeight = meta.height
            } else {
                const { width, height } = await Utils.getImageDimensions(obj.image)
                taskInfo.inputImageWidth = width
                taskInfo.inputImageHeight = height
            }
            taskInfo.inputImageOriginalMask = meta?.originalMask || null
            taskInfo.inputImageEditedMask = meta?.editedMask || null
            taskInfo.inputImageMaskId = meta?.algoId || null
            taskInfo.inputImageColorMaskId = meta?.colorAlgoId || await UtilsAlgo.getModelColorMaskId(taskInfo.inputImage)
        }
        // 模特
        if (requestParam.modelList) taskInfo.modelKeyList = requestParam.modelList
        // 场景
        if (requestParam.bkgList) taskInfo.sceneKeyList = requestParam.bkgList
        // 生成模式
        // taskInfo.customBkgMode = requestParam.customBkgMode
        // 人像皮肤优化
        taskInfo.skinRefine = requestParam.skinRefine
        // 光影融合
        taskInfo.relight = requestParam.relight
        // 光影融合模式
        taskInfo.relightMode = requestParam.relightMode
        // 背输出图分辨率
        taskInfo.resolutionAlign = requestParam.resolutionAlign
        // 资源筛选
        if (requestParam?.attr?.filter) {
            const filter = requestParam?.attr?.filter;
            // 处理年龄和性别的值映射
            if (filter.age && Array.isArray(filter.age)) {
                filter.age = filter.age.map(item => {
                    if (item === "adult") return "青年";
                    if (item === "children") return "大童";
                    return item;
                });
            }
            if (filter.sex && Array.isArray(filter.sex)) {
                filter.sex = filter.sex.map(item => {
                    if (item === "male") return "男";
                    if (item === "female") return "女";
                    return item;
                });
            }
            taskInfo.resourceFilter = filter;
        }
        if (requestParam.emoji) taskInfo.emoji = requestParam.emoji
        // 生成数量
        taskInfo.generateNum = requestParam.num
    } else if (imageType == IMAGE_TYPE.SHOES) {
        pathname = "/home/homemain/shoesTryon"
        const maskByType = requestParam.maskByType
        // 输入图
        if (maskByType.main) {
            const obj = maskByType.main
            const meta = obj.meta
            taskInfo.inputImage = obj.image
            if (meta.width) {
                taskInfo.inputImageWidth = meta.width
                taskInfo.inputImageHeight = meta.height
            } else {
                const { width, height } = await Utils.getImageDimensions(obj.image)
                taskInfo.inputImageWidth = width
                taskInfo.inputImageHeight = height
            }
            taskInfo.inputImageOriginalMask = meta?.originalMask || null
            taskInfo.inputImageEditedMask = meta?.editedMask || null
            taskInfo.inputImageMaskId = meta?.algoId || null
        }
        if (maskByType.angle1) {
            const obj = maskByType.main
            const meta = obj.meta
            taskInfo.no1MultiAngleImage = obj.image
            if (meta.width) {
                taskInfo.no1MultiAngleImageWidth = meta.width
                taskInfo.no1MultiAngleImageHeight = meta.height
            } else {
                const { width, height } = await Utils.getImageDimensions(obj.image)
                taskInfo.no1MultiAngleImageWidth = width
                taskInfo.no1MultiAngleImageHeight = height
            }
            taskInfo.no1MultiAngleImageOriginalMask = meta?.originalMask || null
            taskInfo.no1MultiAngleImageEditedMask = meta?.editedMask || null
            taskInfo.no1MultiAngleImageMaskId = meta?.algoId || null
        }
        if (maskByType.angle2) {
            const obj = maskByType.angle2
            const meta = obj.meta
            taskInfo.no2MultiAngleImage = obj.image
            if (meta.width) {
                taskInfo.no2MultiAngleImageWidth = meta.width
                taskInfo.no2MultiAngleImageHeight = meta.height
            } else {
                const { width, height } = await Utils.getImageDimensions(obj.image)
                taskInfo.no2MultiAngleImageWidth = width
                taskInfo.no2MultiAngleImageHeight = height
            }
            taskInfo.no2MultiAngleImageOriginalMask = meta?.originalMask || null
            taskInfo.no2MultiAngleImageEditedMask = meta?.editedMask || null
            taskInfo.no2MultiAngleImageMaskId = meta?.algoId || null
        }
        // 输入图类型
        if (maskByType.angle1 || maskByType.angle2) {
            taskInfo.currentInputType = INPUT_IMAGE_TYPE.MULTI
        } else {
            taskInfo.currentInputType = INPUT_IMAGE_TYPE.SINGLE
        }
        // 参考图
        if (requestParam.refList) taskInfo.shoesKeyList = requestParam.refList
        // 生成模式
        taskInfo.generateMode = requestParam.mode
        // 资源筛选
        if (requestParam?.attr?.filter) taskInfo.resourceFilter = requestParam?.attr?.filter
        // 生成数量
        taskInfo.generateNum = requestParam.num
    } else if (imageType == IMAGE_TYPE.MODEL_VIDEO) {
        pathname = "/home/homemain/model_video"
        const maskByType = requestParam.maskByType
        // 输入图
        if (maskByType.main) {
            const obj = maskByType.main
            const meta = obj.meta
            taskInfo.inputImage = obj.image
            if (meta.width) {
                taskInfo.inputImageWidth = meta.width
                taskInfo.inputImageHeight = meta.height
            } else {
                const { width, height } = await Utils.getImageDimensions(obj.image)
                taskInfo.inputImageWidth = width
                taskInfo.inputImageHeight = height
            }
        }
        // 视频参考图选择
        if (requestParam.refList?.[0]?.url) taskInfo.videoKeyList = requestParam.refList
        // 资源筛选
        if (requestParam?.attr?.filter) taskInfo.resourceFilter = requestParam?.attr?.filter
        // 生成模式
        if (requestParam.mode) taskInfo.generateMode = requestParam.mode
        // 视频提示词
        if (requestParam.prompt) taskInfo.prompt = requestParam.prompt
        // 人物朝向
        if (requestParam.orientation) taskInfo.orientation = requestParam.orientation
        // 版本号
        taskInfo.version = requestParam?.attr?.version
        // 生成数量
        taskInfo.generateNum = requestParam.num
    } else if (imageType == IMAGE_TYPE.COMMODITY) {
        pathname = "/home/homemain/commodity"
        const maskByType = requestParam.maskByType
        // 输入图
        if (maskByType.main) {
            const obj = maskByType.main
            const meta = obj.meta
            taskInfo.inputImage = obj.image
            if (meta.width) {
                taskInfo.inputImageWidth = meta.width
                taskInfo.inputImageHeight = meta.height
            } else {
                const { width, height } = await Utils.getImageDimensions(obj.image)
                taskInfo.inputImageWidth = width
                taskInfo.inputImageHeight = height
            }
            taskInfo.inputImageOriginalMask = meta?.originalMask || null
            taskInfo.inputImageEditedMask = meta?.editedMask || null
            taskInfo.inputImageMaskId = meta?.algoId || null
            taskInfo.inputImageOriginalMask = meta?.originalMask || null
        }
        // 场景
        if (requestParam.bkgList) taskInfo.sceneKeyList = requestParam.bkgList
        // 场景图模式
        const mode = requestParam.mode
        // 商品自定义场景配置
        taskInfo.refImgConfig = mode != COMMODITY_SCENE_MODE.PRESET ? requestParam.attr?.refImgConfig : null
        // 商品自定义场景强度
        taskInfo.refImgStrength = requestParam.refStrength
        // 商品图输出比例
        taskInfo.outputRatio = requestParam.attr?.outputRatio
        // 商品图输出宽度
        taskInfo.outputWidth = requestParam.attr?.outputWidth
        // 商品图输出高度
        taskInfo.outputHeight = requestParam.attr?.outputHeight
        // 输入图的位置、缩放、尺寸、旋转等信息 (原dragScaleRef.current)
        let inputImageTransform = requestParam.imgDict ? JSON.parse(requestParam.imgDict).find(item => item?.name == "ori") : null

        // ***  (2025-11-27之前的商品数据特殊处理)
        if (requestParam.attr?.version !== 'V3.8.20251127') {
            // 重置imgDict中商品对象的lt_x、lt_y和scale_rate值
            if (inputImageTransform) {
                inputImageTransform.scale_rate = 1.0;
                // 重置中心点位置
                const bgW = requestParam.bkgList[0].attr.width || 2048;
                const bgH = requestParam.bkgList[0].attr.height || 2048;
                const { width, height } = await Utils.getImageDimensions(maskByType.main?.meta?.originalMask?.foregroundMask)
                const imgW = width;
                const imgH = height;
                inputImageTransform.lt_x = (bgW - imgW) / 2;
                inputImageTransform.lt_y = (bgH - imgH) / 2;

            }
            taskInfo.outputRatio = 'custom'
            taskInfo.outputWidth = requestParam.bkgList[0].attr.width || 2048
            taskInfo.outputHeight = requestParam.bkgList[0].attr.height || 2048

            taskInfo.sceneKeyList = requestParam.bkgList.map((item, index) => {
                if (index === 0) {
                    return {
                        ...item,
                        attr: {
                            ...item.attr,
                            originUrl: item.url,
                            refCropUrl: requestParam.bkgList[0].attr.refImage || item.url,
                            width: item.attr.width,
                            height: item.attr.height,
                            commidityOldDataRebuild: commidityOldDataRebuild
                        }
                    }
                } else {
                    return item
                }
            })
        } else {
            taskInfo.sceneKeyList = requestParam.bkgList.map((item, index) => {
                if (index === 0) {
                    return {
                        ...item,
                        attr: {
                            ...item.attr,
                            commidityOldDataRebuild: false
                        }
                    }
                } else {
                    return item
                }
            })
        }
        taskInfo.inputImageTransform = inputImageTransform

        // 生成数量
        taskInfo.generateNum = requestParam.num
        // 生成模式
        if (requestParam.mode) taskInfo.generateMode = requestParam.mode
        // 资源筛选
        if (requestParam?.attr?.filter) taskInfo.resourceFilter = requestParam?.attr?.filter
    } else if (imageType == IMAGE_TYPE.COMMODITYRECOLOR) {
        pathname = "/home/homemain/commodityRecolor"
        const maskByType = requestParam.maskByType
        // 输入图
        if (maskByType.main) {
            const obj = maskByType.main
            const meta = obj.meta
            taskInfo.inputImage = obj.image
            if (meta.width) {
                taskInfo.inputImageWidth = meta.width
                taskInfo.inputImageHeight = meta.height
            } else {
                const { width, height } = await Utils.getImageDimensions(obj.image)
                taskInfo.inputImageWidth = width
                taskInfo.inputImageHeight = height
            }
            taskInfo.inputImageOriginalMask = meta?.originalMask || null
            taskInfo.inputImageEditedMask = meta?.editedMask || null
            taskInfo.inputImageMaskId = meta?.algoId || null
            taskInfo.inputImageMultiSemanticId = meta?.inputImageMultiSemanticId || null
        }
        // 目标颜色
        if (requestParam.color) taskInfo.colorKeyList = [requestParam.color]
        // 资源筛选
        if (requestParam?.attr?.filter) taskInfo.resourceFilter = requestParam?.attr?.filter
        // 生成模式
        if (requestParam.hdMode) taskInfo.generateMode = requestParam.hdMode
        // 生成数量
        taskInfo.generateNum = requestParam.num
    } else if (imageType == IMAGE_TYPE.CLOTH_RECOLOR) {
        pathname = "/home/homemain/clothRecolor"
        if (requestParam.mode == CLOTH_COLOR_TYPE.CLOTH_RECOLOR) {
            const maskByType = requestParam.maskByType
            // 输入图
            if (maskByType.main) {
                const obj = maskByType.main
                const meta = obj.meta
                taskInfo.inputImage = obj.image
                if (meta.width) {
                    taskInfo.inputImageWidth = meta.width
                    taskInfo.inputImageHeight = meta.height
                } else {
                    const { width, height } = await Utils.getImageDimensions(obj.image)
                    taskInfo.inputImageWidth = width
                    taskInfo.inputImageHeight = height
                }
                taskInfo.inputImageOriginalMask = meta?.originalMask || null
                taskInfo.inputImageEditedMask = meta?.editedMask || null
                taskInfo.inputImageMaskId = meta?.algoId || null
                taskInfo.inputImageMultiSemanticId = meta?.inputImageMultiSemanticId || null
                taskInfo.clothReColorIsPerson = requestParam?.attr?.clothReColorIsPerson || false
            }
            taskInfo.currentClothColorType = CLOTH_COLOR_TYPE.CLOTH_RECOLOR
            // 目标颜色
            if (requestParam.color) taskInfo.clothColorKeyList = [requestParam.color]
        } else {
            pathname = "/home/homemain/clothRecolor"
            const maskByType = requestParam.maskByType
            const isMaterialRecolorMode = requestParam.mode == INPUT_IMAGE_TYPE.MATERIAL
            // 输入图
            if (maskByType.main) { // 单件服装
                const obj = maskByType.main
                const meta = obj.meta
                taskInfo.inputImage = obj.image
                if (meta.width) {
                    taskInfo.inputImageWidth = meta.width
                    taskInfo.inputImageHeight = meta.height
                } else {
                    const { width, height } = await Utils.getImageDimensions(obj.image)
                    taskInfo.inputImageWidth = width
                    taskInfo.inputImageHeight = height
                }
                taskInfo.inputImageOriginalMask = meta?.originalMask || null
                taskInfo.inputImageEditedMask = meta?.editedMask || null
                taskInfo.inputImageMaskId = meta?.algoId || null
                taskInfo.inputImageClothType = meta?.clothType || null

            }
            if (maskByType.inputCloth) {
                const obj = maskByType.inputCloth
                const meta = obj.meta
                if (isMaterialRecolorMode) {
                    taskInfo.materialInputImage = obj.image
                    if (meta.width) {
                        taskInfo.materialInputImageWidth = meta.width
                        taskInfo.materialInputImageHeight = meta.height
                    } else {
                        const { width, height } = await Utils.getImageDimensions(obj.image)
                        taskInfo.materialInputImageWidth = width
                        taskInfo.materialInputImageHeight = height
                    }
                    taskInfo.materialInputImageClothType = ['top', 'bottom', 'dress'][requestParam?.clothType] || 'top'
                    // 输入图类型
                    taskInfo.currentInputType = INPUT_IMAGE_TYPE.MATERIAL
                } else if (meta.algoId) {
                    taskInfo.mainInputImage = obj.image
                    if (meta.width) {
                        taskInfo.mainInputImageWidth = meta.width
                        taskInfo.mainInputImageHeight = meta.height
                    } else {
                        const { width, height } = await Utils.getImageDimensions(obj.image)
                        taskInfo.mainInputImageWidth = width
                        taskInfo.mainInputImageHeight = height
                    }
                    taskInfo.mainInputImageOriginalMask = meta?.originalMask || null
                    taskInfo.mainInputImageEditedMask = meta?.editedMask || null
                    taskInfo.mainInputImageMaskId = meta?.algoId || null
                    taskInfo.mainInputImageClothType = ['top', 'bottom', 'dress'][requestParam?.clothType] || 'top'

                    // 输入图类型
                    taskInfo.currentInputType = INPUT_IMAGE_TYPE.SINGLE
                } else {
                    taskInfo.materialInputImage = obj.image
                    if (meta.width) {
                        taskInfo.materialInputImageWidth = meta.width
                        taskInfo.materialInputImageHeight = meta.height
                    } else {
                        const { width, height } = await Utils.getImageDimensions(obj.image)
                        taskInfo.materialInputImageWidth = width
                        taskInfo.materialInputImageHeight = height
                    }
                    taskInfo.materialInputImageClothType = ['top', 'bottom', 'dress'][requestParam?.clothType] || 'top'
                    // 输入图类型
                    taskInfo.currentInputType = INPUT_IMAGE_TYPE.MATERIAL
                }
            } else if (maskByType.topCloth || maskByType.bottom) { // 上下搭配
                if (maskByType.topCloth) {
                    const obj = maskByType.topCloth
                    const meta = obj.meta
                    taskInfo.topInputImage = obj.image
                    if (meta.width) {
                        taskInfo.topInputImageWidth = meta.width
                        taskInfo.topInputImageHeight = meta.height
                    } else {
                        const { width, height } = await Utils.getImageDimensions(obj.image)
                        taskInfo.topInputImageWidth = width
                        taskInfo.topInputImageHeight = height
                    }
                    taskInfo.topInputImageOriginalMask = meta?.originalMask || null
                    taskInfo.topInputImageEditedMask = meta?.editedMask || null
                    taskInfo.topInputImageMaskId = meta?.algoId || null
                }
                if (maskByType.bottomCloth) {
                    const obj = maskByType.bottomCloth
                    const meta = obj.meta
                    taskInfo.bottomInputImage = obj.image
                    if (meta.width) {
                        taskInfo.bottomInputImageWidth = meta.width
                        taskInfo.bottomInputImageHeight = meta.height
                    } else {
                        const { width, height } = await Utils.getImageDimensions(obj.image)
                        taskInfo.bottomInputImageWidth = width
                        taskInfo.bottomInputImageHeight = height
                    }
                    taskInfo.bottomInputImageOriginalMask = meta?.originalMask || null
                    taskInfo.bottomInputImageEditedMask = meta?.editedMask || null
                    taskInfo.bottomInputImageMaskId = meta?.algoId || null
                }
                // 输入图类型
                taskInfo.currentInputType = INPUT_IMAGE_TYPE.MULTI
            }

            taskInfo.currentClothColorType = CLOTH_COLOR_TYPE.SIM_RECOLOR
        }

        // 生成数量
        taskInfo.generateNum = requestParam.num

    } else if (imageType == IMAGE_TYPE.IMAGE_TO_VIDEO) {
        pathname = "/home/homemain/model_video_img"
        const maskByType = requestParam.maskByType
        // 输入图
        if (maskByType.main) {
            const obj = maskByType.main
            const meta = obj.meta
            taskInfo.inputImage = obj.image
            if (meta.width) {
                taskInfo.inputImageWidth = meta.width
                taskInfo.inputImageHeight = meta.height
            } else {
                const { width, height } = await Utils.getImageDimensions(obj.image)
                taskInfo.inputImageWidth = width
                taskInfo.inputImageHeight = height
            }
        }
        // 视频时长
        if (requestParam.duration) taskInfo.duration = Number(requestParam.duration)
        // 视频提示词
        if (requestParam.prompt) taskInfo.prompt = requestParam.prompt
        // 生成模式
        if (requestParam.mode) taskInfo.generateMode = requestParam.mode
        // 尾帧图
        if (requestParam.imageTail) taskInfo.no1MultiAngleImage = requestParam.imageTail
        // 生成数量
        taskInfo.generateNum = requestParam.num
    } else if (imageType == IMAGE_TYPE.CREATIVE_IMAGE_GEN) {
        pathname = "/home/homemain/creativeToImage"
        if (requestParam.refImages?.length > 0) taskInfo.matchImages = requestParam.refImages
        else if (requestParam.matchImages?.length > 0) taskInfo.matchImages = requestParam.matchImages
        if (requestParam.prompt) taskInfo.prompt = requestParam.prompt
        if (requestParam.mode) taskInfo.imageSize = requestParam.mode
        taskInfo.aspectRatio = requestParam.aspectRatio || requestParam.attr?.aspectRatio || RESOLUTION_RATIO.THREE_FOUR
        taskInfo.generateNum = requestParam.num
    } else if (imageType == IMAGE_TYPE.FUSION_WEAR) {
        pathname = "/home/homemain/fusionWear"

        // 搭配图
        if (requestParam.matchImages.length > 0) taskInfo.matchImages = requestParam.matchImages
        // 提示词
        if (requestParam.prompt) taskInfo.prompt = requestParam.prompt
        // 生成模式
        if (requestParam.mode) taskInfo.generateMode = requestParam.mode
        // 模特图
        if (requestParam.modelImage) taskInfo.modelImage = [requestParam.modelImage]
        // 生成数量
        taskInfo.generateNum = requestParam.num
    } else if (imageType == IMAGE_TYPE.GRASS_PLANT || imageType == IMAGE_TYPE.SMART_DETAILA_PAGE) {
        pathname = imageType == IMAGE_TYPE.GRASS_PLANT ? "/home/homemain/grassPlant" : "/home/homemain/smartDetailPage"
        const maskByType = requestParam.maskByType
        // 输入图
        if (maskByType.main) {
            const obj = maskByType.main
            const meta = obj.meta
            taskInfo.inputImage = obj.image
            if (meta.width) {
                taskInfo.inputImageWidth = meta.width
                taskInfo.inputImageHeight = meta.height
            } else {
                const { width, height } = await Utils.getImageDimensions(obj.image)
                taskInfo.inputImageWidth = width
                taskInfo.inputImageHeight = height
            }
        }
        // 生成模式
        taskInfo.generateMode = requestParam.mode
        // 生成数量
        taskInfo.generateNum = requestParam.num
        // 网红模特
        if (requestParam.modelList) taskInfo.modelKeyList = requestParam.modelList
        // 场景
        if (requestParam.bkgList) taskInfo.sceneKeyList = requestParam.bkgList
        if (imageType == IMAGE_TYPE.SMART_DETAILA_PAGE) {
            const ecPlatformMap = {
                '淘宝': 'taobao',
                '天猫': 'tmall',
                '京东': 'jd',
                '拼多多': 'pdd',
                '抖音电商': 'douyin_shop',
                '唯品会': 'vip',
                '1688': '1688',
                '小红书': 'xiaohongshu',
                '亚马逊': 'amazon',
                'Tik Tok': 'tiktok',
                'Shopify': 'shopify',
            }
            const customCategoryToItem = {
                heroPoster: { key: 'poster', label: '首屏海报', min: 1, fixed: true, comp: 0 },
                sellingPoints: { key: 'sellingPoint', label: '产品卖点', min: 1, comp: 1 },
                buyerShow: { key: 'buyerShow', label: '痛点解决', min: 0, comp: 2 },
                lifestyleOutfit: { key: 'sceneStyling', label: '场景化穿搭', min: 0, comp: 3 },
                productInfo: { key: 'productInfo', label: '产品信息', min: 0, comp: 4 },
                productDetails: { key: 'productDetail', label: '产品细节', min: 0, comp: 5 },
                sizeChart: { key: 'sizeChart', label: '尺码表', min: 0, comp: 6 },
                shoppingGuarantee: { key: 'serviceGuarantee', label: '购物保障', min: 0, comp: 7 },
            }
            taskInfo.matchImages = requestParam.refImages || []
            taskInfo.prompt = requestParam.prompt || ''
            taskInfo.smartDetailClarity = requestParam.mode?.toLowerCase?.() === '4k' ? '4k' : '2k'
            taskInfo.smartDetailRatio = requestParam.aspectRatio || '3:4'
            taskInfo.smartDetailPlatform = ecPlatformMap[requestParam.ecPlatform] || 'taobao'
            taskInfo.smartDetailLang = requestParam.lang || 'cn'
            const hasRefTemplateField = Object.prototype.hasOwnProperty.call(requestParam || {}, 'refTemplate')
            if (hasRefTemplateField) {
                taskInfo.tryonModelKeyList = requestParam.refTemplate ? [requestParam.refTemplate] : []
                taskInfo.smartDetailMode = 'reference'
            } else {
                taskInfo.smartDetailMode = 'detail'
            }
            if (Array.isArray(requestParam.customCompList)) {
                taskInfo.smartDetailCustomItemList = requestParam.customCompList
                    .map((item) => {
                        const base = customCategoryToItem[item?.category]
                        if (!base) return null
                        const num = Number(item?.num)
                        const safeNum = Number.isFinite(num) ? num : (base.min || 0)
                        return {
                            ...base,
                            value: safeNum,
                            checked: safeNum > 0,
                        }
                    })
                    .filter(Boolean)
            }
        }
    } else if (imageType == IMAGE_TYPE.WATERMARK_REMOVE) {
        pathname = "/home/homemain/watermarkRemove"
        const maskByType = requestParam.maskByType
        // 输入图
        if (maskByType.main) {
            const obj = maskByType.main
            const meta = obj.meta
            taskInfo.inputImage = obj.image
            if (meta.width) {
                taskInfo.inputImageWidth = meta.width
                taskInfo.inputImageHeight = meta.height
            } else {
                const { width, height } = await Utils.getImageDimensions(obj.image)
                taskInfo.inputImageWidth = width
                taskInfo.inputImageHeight = height
            }
        }
        // 生成数量
        taskInfo.generateNum = requestParam.num
    } else {
        throw new Error("版本已更新，无法复用之前的选择")
    }
    return {
        taskInfo,
        pathname
    }
}

// 重新编辑
export const workflowOfLoadTaskInfo = async (imageType, taskId, commidityOldDataRebuild) => {
    try {
        const res = await API.getTaskRequestParam({ taskId })
        if (res.code != 0) throw new Error(res.message)
        const requestParam = res.data
        if (!requestParam) {
            const res = await API.getTaskInfo({ taskId })
            if (res.code != 0) throw new Error(res.message)
            const projectId = res.data.projectId
            const { taskInfo, pathname } = await handleDeprecatedInputParam(res.data, imageType)
            taskInfo.projectId = projectId
            const options = { state: { taskInfo } }
            return {
                pathname,
                options
            }
        } else {
            const projectId = requestParam.projectId
            const { taskInfo, pathname } = await handleInputParam(requestParam, imageType, commidityOldDataRebuild)
            taskInfo.projectId = projectId
            const options = { state: { taskInfo } }
            return {
                pathname,
                options
            }
        }
    } catch (err) {
        console.error(err)
        message.warning(err.message)
    }
}

// 功能串联 src\view\page_v3\Layout文件赋值
export const workflowOfSendTask = async (imageType, url, target = "inputImage", extraState = {}) => {
    try {
        let pathname = ""
        if (imageType == IMAGE_TYPE.CLOTHES) {
            pathname = "/home/homemain/clothes"
        } else if (imageType == IMAGE_TYPE.POSE_TRYON) {
            pathname = "/home/homemain/poseTryon"
        } else if (imageType == IMAGE_TYPE.GLASSES_TRYON) {
            pathname = "/home/homemain/glassesTryon"
        } else if (imageType == IMAGE_TYPE.NECKLACE_TRYON) {
            pathname = "/home/homemain/necklaceTryon"
        } else if (imageType == IMAGE_TYPE.SIM_TRYON) {
            pathname = "/home/homemain/simTryon"
        } else if (imageType == IMAGE_TYPE.MODEL) {
            pathname = "/home/homemain/model"
        } else if (imageType == IMAGE_TYPE.BACKGROUND) {
            pathname = "/home/homemain/background"
        } else if (imageType == IMAGE_TYPE.SHOES) {
            pathname = "/home/homemain/shoesTryon"
        } else if (imageType == IMAGE_TYPE.MODEL_VIDEO) {
            pathname = "/home/homemain/model_video"
        } else if (imageType == IMAGE_TYPE.COMMODITY) {
            pathname = "/home/homemain/commodity"
        } else if (imageType == IMAGE_TYPE.COMMODITYRECOLOR) {
            pathname = "/home/homemain/commodityRecolor"
        } else if (imageType == IMAGE_TYPE.CLOTH_RECOLOR) {
            pathname = "/home/homemain/clothRecolor"
        } else if (imageType == IMAGE_TYPE.IMAGE_TO_VIDEO) {
            pathname = "/home/homemain/model_video_img"
        } else if (imageType == IMAGE_TYPE.CREATIVE_IMAGE_GEN) {
            pathname = "/home/homemain/creativeToImage"
        } else if (imageType == IMAGE_TYPE.FUSION_WEAR) {
            pathname = "/home/homemain/fusionWear"
        } else if (imageType == IMAGE_TYPE.GRASS_PLANT) {
            pathname = "/home/homemain/grassPlant"
        } else if (imageType == IMAGE_TYPE.SMART_DETAILA_PAGE) {
            pathname = "/home/homemain/smartDetailPage"
        } else if (imageType == IMAGE_TYPE.WATERMARK_REMOVE) {
            pathname = "/home/homemain/watermarkRemove"
        }
        return {
            pathname,
            options: { state: { url, target, imageType, ...extraState } }
        }
    } catch (err) {
        console.error(err)
        message.warning(err.message)
    }
}

// 生成
export const workflowOfGenerate = async (imageType, data, extra = {}) => {
    const inputParams = await formatInputParams(imageType, data)
    if (!inputParams) throw new Error("暂不支持生成")
    if (imageType == IMAGE_TYPE.CLOTHES) {
        const res = await API.doTryonInpaint({ ...inputParams, ...extra })
        if (res.code != 0) throw new Error(res.message)
        console.log("dotryon", res.data)
        eventBus.emit('updatePower')
        return res.data.id
    } else if (imageType == IMAGE_TYPE.POSE_TRYON) {
        const res = await API.doPoseTryonInpaint({ ...inputParams, ...extra })
        if (res.code != 0) throw new Error(res.message)
        console.log("doPoseTryon", res.data)
        eventBus.emit('updatePower')
        return res.data.id
    } else if (imageType == IMAGE_TYPE.GLASSES_TRYON) {
        const res = await API.doGlassesTryonInpaint({ ...inputParams, ...extra })
        if (res.code != 0) throw new Error(res.message)
        console.log("doGrassesTryon", res.data)
        eventBus.emit('updatePower')
        return res.data.id
    } else if (imageType == IMAGE_TYPE.NECKLACE_TRYON) {
        const res = await API.doJewelryTryOn({ ...inputParams, ...extra })
        if (res.code != 0) throw new Error(res.message)
        console.log("doNecklaceTryon", res.data)
        eventBus.emit('updatePower')
        return res.data.id
    } else if (imageType == IMAGE_TYPE.SIM_TRYON) {
        const res = await API.doSimTryonInpaint({ ...inputParams, ...extra })
        if (res.code != 0) throw new Error(res.message)
        console.log("doSimTryon", res.data)
        eventBus.emit('updatePower')
        return res.data.id
    } else if (imageType == IMAGE_TYPE.MODEL || imageType == IMAGE_TYPE.BACKGROUND) {
        const res = await API.doModelInpaint({ ...inputParams, ...extra })
        if (res.code != 0) throw new Error(res.message)
        console.log("doModel", res.data)
        eventBus.emit('updatePower')
        return res.data.id
    } else if (imageType == IMAGE_TYPE.SHOES) {
        const res = await API.doShoesTryonInpaint({ ...inputParams, ...extra })
        if (res.code != 0) throw new Error(res.message)
        console.log("doShoesTryon", res.data)
        eventBus.emit('updatePower')
        return res.data.id
    } else if (imageType == IMAGE_TYPE.MODEL_VIDEO) {
        const res = await API.doVideoTryonInpaint({ ...inputParams, ...extra })
        if (res.code != 0) throw new Error(res.message)
        console.log("doVideoTryon", res.data)
        eventBus.emit('updatePower')
        return res.data.id
    } else if (imageType == IMAGE_TYPE.COMMODITY) {
        const res = await API.doCommodityInpaint({ ...inputParams, ...extra })
        if (res.code != 0) throw new Error(res.message)
        console.log("doCommodity", res.data)
        eventBus.emit('updatePower')
        return res.data.id
    } else if (imageType == IMAGE_TYPE.COMMODITYRECOLOR) {
        const res = await API.doCommodityRecolorInpaint({ ...inputParams, ...extra })
        if (res.code != 0) throw new Error(res.message)
        console.log("doCommodityRecolor", res.data)
        eventBus.emit('updatePower')
        /** 保存颜色 begin **/
        const selectedColor = inputParams.color
        const colorHistory = JSON.parse(localStorage.getItem('AIEditColorList') || '[]')
        const filteredHistory = colorHistory.filter(color => color !== selectedColor)
        filteredHistory.unshift(selectedColor)

        const latestColors = filteredHistory.slice(0, 10)
        localStorage.setItem('AIEditColorList', JSON.stringify(latestColors))
        /** 保存颜色 end **/
        return res.data.id
    } else if (imageType == IMAGE_TYPE.CLOTH_RECOLOR) {
        const res = await API.doClothRecolorInpaint({ ...inputParams, ...extra })
        if (res.code != 0) throw new Error(res.message)
        console.log("doClothRecolor", res.data)
        eventBus.emit('updatePower')
        // 保存颜色 
        if (inputParams.color) {
            const selectedColor = inputParams.color
            const colorHistory = JSON.parse(localStorage.getItem('AIEditColorList') || '[]')
            const filteredHistory = colorHistory.filter(color => color !== selectedColor)
            filteredHistory.unshift(selectedColor)
            const latestColors = filteredHistory.slice(0, 10)
            localStorage.setItem('AIEditColorList', JSON.stringify(latestColors))
        }
        return res.data.id
    } else if (imageType == IMAGE_TYPE.IMAGE_TO_VIDEO) {
        const res = await API.doImage2Video({ ...inputParams, ...extra })
        if (res.code != 0) throw new Error(res.message)
        console.log("doImgToVideo", res.data)
        eventBus.emit('updatePower')
        return res.data.id
    } else if (imageType == IMAGE_TYPE.CREATIVE_IMAGE_GEN) {
        const res = await API.doCreativeImageGen({ ...inputParams, ...extra })
        if (res.code != 0) throw new Error(res.message)
        eventBus.emit('updatePower')
        return res.data.id
    } else if (imageType == IMAGE_TYPE.FUSION_WEAR) {
        const res = await API.doFusionWear({ ...inputParams, ...extra })
        if (res.code != 0) throw new Error(res.message)
        eventBus.emit('updatePower')
        return res.data.id
    } else if (imageType == IMAGE_TYPE.GRASS_PLANT) {
        const res = await API.doGrassPlant({ ...inputParams, ...extra })
        if (res.code != 0) throw new Error(res.message)
        eventBus.emit('updatePower')
        return res.data.id
    } else if (imageType == IMAGE_TYPE.SMART_DETAILA_PAGE) {
        const { projectId: _ignoredProjectId, ...safeExtra } = extra || {}
        const res = await API.doSmartDetailPage({ ...inputParams, ...safeExtra })
        if (res.code != 0) throw new Error(res.message)
        eventBus.emit('updatePower')
        return res.data.id
    } else if (imageType == IMAGE_TYPE.WATERMARK_REMOVE) {
        const res = await API.doWatermarkRemove({ ...inputParams, ...extra })
        if (res.code != 0) throw new Error(res.message)
        eventBus.emit('updatePower')
        return res.data.id
    }
}

// 再次生成
export const workflowOfReGenerate = async (imageType, taskId) => {
    try {
        const res = await API.getTaskRequestParam({ taskId })
        if (res.code != 0) throw new Error(res.message)
        const requestParam = res.data
        let taskInfo, pathname
        if (!requestParam) {
            const res = await API.getTaskInfo({ taskId })
            if (res.code != 0) throw new Error(res.message)
            const projectId = res.data.projectId
            const res2 = await handleDeprecatedInputParam(res.data, imageType)
            taskInfo = res2.taskInfo
            taskInfo.projectId = projectId
            pathname = res2.pathname
        } else {
            const projectId = requestParam.projectId
            const res2 = await handleInputParam(requestParam, imageType)
            taskInfo = res2.taskInfo
            taskInfo.projectId = projectId
            pathname = res2.pathname
        }

        // 提取本次任务的指定参数
        const res2 = await API.getTaskInfoV2({ taskId })
        if (res2.code != 0) throw new Error(res2.message)
        // console.log('res2.data', res2.data)
        // console.log('taskinfo', taskInfo)
        // 还原该任务的生成参数
        const task = res2.data.task
        const background = task.background
        const person = task.person
        const pose = task.pose
        const videoRef = task.videoRef
        const shoesRef = task.shoesRef
        const poseRef = task.poseRef
        const glassesRef = task.glassesRef
        const jewelryRef = task.jewelryRef || task.glassesRef
        const poseRefSim = task.poseRef
        const keepBkg = task.keepBkg
        const keepPose = task.keepPose

        if (keepBkg) taskInfo.sceneKeyList = []
        else if (background) taskInfo.sceneKeyList = taskInfo.sceneKeyList.filter(item => item.key == background?.key || compareFilenames(item.url, background?.url))
        if (keepPose) taskInfo.modelKeyList = []
        else if (person) taskInfo.modelKeyList = taskInfo.modelKeyList.filter(item => item.key == person?.key || compareFilenames(item.url, person?.url))
        if (pose) taskInfo.tryonModelKeyList = taskInfo.tryonModelKeyList.filter(item => item.key == pose?.key || compareFilenames(item.url, pose?.url))
        if (videoRef) {
            if ((!taskInfo.videoKeyList || taskInfo.videoKeyList.length == 0) && imageType == IMAGE_TYPE.MODEL_VIDEO) {
                message.error('原参考视频已被删除，无法再次生成')
                return false
            }
            taskInfo.videoKeyList = taskInfo.videoKeyList?.filter(item => item.key == videoRef?.key || compareFilenames(item.url, videoRef?.url))
        }
        if (shoesRef) taskInfo.shoesKeyList = taskInfo.shoesKeyList.filter(item => item.key == shoesRef?.key || compareFilenames(item.url, shoesRef?.url))
        if (poseRef && imageType == IMAGE_TYPE.POSE_TRYON) taskInfo.poseTryonKeyList = taskInfo.poseTryonKeyList.filter(item => item.key == poseRef?.key || compareFilenames(item.url, poseRef?.url))
        if (glassesRef && imageType == IMAGE_TYPE.GLASSES_TRYON) taskInfo.glassesTryonKeyList = taskInfo.glassesTryonKeyList.filter(item => item.key == glassesRef?.key || compareFilenames(item.url, glassesRef?.url))
        if (jewelryRef && imageType == IMAGE_TYPE.NECKLACE_TRYON) taskInfo.necklaceTryonKeyList = taskInfo.necklaceTryonKeyList.filter(item => item.key == jewelryRef?.key || compareFilenames(item.url, jewelryRef?.url))
        if (poseRefSim && imageType == IMAGE_TYPE.SIM_TRYON) taskInfo.simTryonKeyList = taskInfo.simTryonKeyList.filter(item => item.key == poseRef?.key || compareFilenames(item.url, poseRef?.url))

        const disabled = generateDisabled(imageType, taskInfo)
        if (disabled) {
            const options = { state: { taskInfo } }
            return {
                disabled: true,
                pathname,
                options
            }
        } else {
            if (imageType == IMAGE_TYPE.MODEL_VIDEO && taskInfo?.version != 'V3.12.20260122') {
                const costBean = (Math.round(taskInfo?.videoKeyList?.[0]?.attr?.duration / 1000)) * 25 || ''
                return new Promise((resolve) => {
                    PSAIModal.confirm({
                        content: `视频功能已升级，虹豆将按新的计费标准收取${costBean}，是否继续？`,
                        okText: '确定',
                        cancelText: '取消',
                        async onOk() {
                            try {
                                await workflowOfGenerate(imageType, taskInfo, {
                                    projectId: taskInfo.projectId
                                })
                                resolve({
                                    disabled: false
                                })
                            } catch (err) {
                                resolve(false)
                                throw err
                            }
                        },
                        onCancel() {
                            resolve(false)
                        },
                    })
                })
            } else {
                await workflowOfGenerate(imageType, taskInfo, {
                    projectId: taskInfo.projectId
                })
                return {
                    disabled: false
                }
            }

        }
    } catch (err) {
        console.error(err)
        message.warning(err.message)
        return false
    }
}

// 更换容貌/更换场景
export const workflowOfChange = async (imageType, taskId, changed) => {
    try {
        const res = await API.getTaskRequestParam({ taskId })
        if (res.code != 0) throw new Error(res.message)
        const requestParam = res.data
        let taskInfo, pathname
        if (!requestParam) {
            const res = await API.getTaskInfo({ taskId })
            if (res.code != 0) throw new Error(res.message)
            const projectId = res.data.projectId
            const res2 = await handleDeprecatedInputParam(res.data, imageType)
            taskInfo = res2.taskInfo
            taskInfo.projectId = projectId
            pathname = res2.pathname
        } else {
            const projectId = requestParam.projectId
            const res2 = await handleInputParam(requestParam, imageType)
            taskInfo = res2.taskInfo
            taskInfo.projectId = projectId
            pathname = res2.pathname
        }

        // 更换容貌/更换场景 生成数量为1
        taskInfo.generateNum = 1

        // 提取本次任务的指定参数
        const res2 = await API.getTaskInfoV2({ taskId })
        if (res2.code != 0) throw new Error(res2.message)
        // console.log('res2.data', res2.data)
        // console.log('taskinfo', taskInfo)
        // console.log('changed', changed)
        // 还原该任务的生成参数
        const task = res2.data.task
        const background = task.background
        const person = task.person
        const pose = task.pose
        const videoRef = task.videoRef
        const shoesRef = task.shoesRef
        const keepBkg = task.keepBkg
        const keepPose = task.keepPose
        if (keepBkg) taskInfo.sceneKeyList = []
        else if (background) taskInfo.sceneKeyList = taskInfo.sceneKeyList.filter(item => item.key == background?.key || compareFilenames(item.url, background?.url))
        if (keepPose) taskInfo.modelKeyList = []
        else if (person) taskInfo.modelKeyList = taskInfo.modelKeyList.filter(item => item.key == person?.key || compareFilenames(item.url, person?.url))
        if (pose) taskInfo.tryonModelKeyList = taskInfo.tryonModelKeyList.filter(item => item.key == pose?.key || compareFilenames(item.url, pose?.url))
        if (videoRef) taskInfo.videoKeyList = taskInfo.videoKeyList.filter(item => item.key == videoRef?.key || compareFilenames(item.url, videoRef?.url))
        if (shoesRef) taskInfo.shoesKeyList = taskInfo.shoesKeyList.filter(item => item.key == shoesRef?.key || compareFilenames(item.url, shoesRef?.url))

        // 修改指定生成参数
        if (changed.modelKeyList) taskInfo.modelKeyList = [...changed.modelKeyList]
        if (changed.sceneKeyList) taskInfo.sceneKeyList = [...changed.sceneKeyList]
        if (changed.videoKeyList) taskInfo.videoKeyList = [...changed.videoKeyList]
        if (changed.shoesKeyList) taskInfo.shoesKeyList = [...changed.shoesKeyList]

        const disabled = generateDisabled(imageType, taskInfo)
        if (disabled) {
            const options = { state: { taskInfo } }
            return {
                disabled: true,
                pathname,
                options
            }
        } else {
            await workflowOfGenerate(imageType, taskInfo, {
                projectId: taskInfo.projectId
            })
            return {
                disabled: false
            }
        }
    } catch (err) {
        console.error(err)
        message.warning(err.message)
        return false
    }
}

// 复用
export const workflowOfReplica = async (imageType, taskId, file, num) => {
    // 违规图片重新上传
    const illegalAndReuploadHandle = async () => {
        return new Promise((resolve, reject) => {
            PSAIModal.confirm({
                content: '经检测，您上传的内容涉嫌违规，已进行屏蔽处理，人工审核会对图片进行复核。',
                okText: '重新上传',
                cancelText: '取消',
                onOk() {
                    Utils.openFile().then((file) => {
                        if (file) {
                            uploadFile(file).then(resolve)
                        } else {
                            resolve(false)
                        }
                    }).catch(err => {
                        resolve(false)
                    })
                },
                onCancel() {
                    resolve(false)
                },
            })
        })
    }
    // 上传文件
    const uploadFile = async (file) => {
        // 检查图像是否符合要求
        const validate = await Utils.validateImageFile(file)
        if (!validate) return false
        // 图片最大尺寸重置4096
        const resizeRes = await Utils.resizeImageFileMaxByAliyunBy(file, 4096)
        if (!resizeRes || !resizeRes.success) throw new Error(resizeRes?.message)
        file = resizeRes.file
        const inputImageWidth = resizeRes.width
        const inputImageHeight = resizeRes.height
        // 检查上传图片是否符合安全规范
        const legalRes = await Utils.checkImageIslegal(file, 0, UPLOAD_SOURCE.MODEL)
        if (!legalRes) return false
        if (!legalRes.isLegal) return await illegalAndReuploadHandle()
        const imageUrl = legalRes.data
        return {
            url: imageUrl,
            width: inputImageWidth,
            height: inputImageHeight,
        }
    }
    // 处理url
    const processUrl = async (url, width, height) => {
        // const imageAntispamId = legalRes.imageAntispamId
        const imageUrl = url
        const inputImageWidth = width
        const inputImageHeight = height
        // clothMaskId
        let clothMaskId = await UtilsAlgo.getModelMaskId(imageUrl)
        let originalMask = null
        if (clothMaskId) {
            let editedMask = await UtilsAlgo.getClothMaskOutput(clothMaskId)
            originalMask = editedMask
        }
        const colorMaskId = await UtilsAlgo.getModelColorMaskId(imageUrl)
        const result = {
            inputImage: imageUrl, // 图片url
            clothMaskId, // 服装maskId
            colorMaskId,
            originalMask,
            inputImageWidth,
            inputImageHeight,
        }
        return result
    }
    try {
        // 上传图片
        let replicaObj = null
        if (Boolean) {
            const res = await uploadFile(file)
            if (!res) return false
            const res2 = await processUrl(res.url, res.width, res.height)
            replicaObj = res2
        }

        const res = await API.getTaskRequestParam({ taskId })
        if (res.code != 0) throw new Error(res.message)
        const requestParam = res.data
        let taskInfo, pathname
        if (!requestParam) {
            const res = await API.getTaskInfo({ taskId })
            if (res.code != 0) throw new Error(res.message)
            const projectId = res.data.projectId
            const res2 = await handleDeprecatedInputParam(res.data, imageType)
            taskInfo = res2.taskInfo
            taskInfo.projectId = projectId
            pathname = res2.pathname
        } else {
            const projectId = requestParam.projectId
            const res2 = await handleInputParam(requestParam, imageType)
            taskInfo = res2.taskInfo
            taskInfo.projectId = projectId
            pathname = res2.pathname
        }

        // 提取本次任务的指定参数
        const res2 = await API.getTaskInfoV2({ taskId })
        if (res2.code != 0) throw new Error(res2.message)
        // 还原该任务的生成参数
        const task = res2.data.task
        const background = task.background
        const person = task.person
        const pose = task.pose
        const videoRef = task.videoRef
        const shoesRef = task.shoesRef
        const keepBkg = task.keepBkg
        const keepPose = task.keepPose
        if (keepBkg) taskInfo.sceneKeyList = []
        else if (background) taskInfo.sceneKeyList = taskInfo.sceneKeyList.filter(item => item.key == background?.key || compareFilenames(item.url, background?.url))
        if (keepPose) taskInfo.modelKeyList = []
        else if (person) taskInfo.modelKeyList = taskInfo.modelKeyList.filter(item => item.key == person?.key || compareFilenames(item.url, person?.url))
        if (pose) taskInfo.tryonModelKeyList = taskInfo.tryonModelKeyList.filter(item => item.key == pose?.key || compareFilenames(item.url, pose?.url))
        if (videoRef) taskInfo.videoKeyList = taskInfo.videoKeyList.filter(item => item.key == videoRef?.key || compareFilenames(item.url, videoRef?.url))
        if (shoesRef) taskInfo.shoesKeyList = taskInfo.shoesKeyList.filter(item => item.key == shoesRef?.key || compareFilenames(item.url, shoesRef?.url))

        // 组合复刻参数
        const {
            inputImage, // 图片url
            clothMaskId, // 服装maskId
            colorMaskId,
            originalMask,
            inputImageWidth,
            inputImageHeight,
        } = replicaObj
        taskInfo = {
            ...taskInfo,
            inputImage,
            inputImageWidth,
            inputImageHeight,
            inputImageMaskId: clothMaskId,
            inputImageOriginalMask: originalMask,
            inputImageEditedMask: null,
            inputImageColorMaskId: colorMaskId,
            generateNum: num
        }
        // 复刻生成
        const disabled = generateDisabled(imageType, taskInfo)
        if (!disabled) {
            await workflowOfGenerate(imageType, taskInfo, {
                taskId: taskId
            })
            return true
        } else {
            return false
        }
    } catch (err) {
        console.error(err)
        message.warning(err.message)
        return false
    }
}

// 全局高清下载
export const queryHDStatusv2 = async (HDCurrentList, removeTaskFromListCallback) => {
    try {
        const res = await commonApiInvoker(API.queryHDStatusv2({ taskIds: HDCurrentList }))
        if (res && Array.isArray(res)) {
            const downloadPromises = []

            res.forEach(item => {
                if (item.imageResult && Array.isArray(item.imageResult)) {
                    item.imageResult.forEach(result => {
                        if (result.hdStatus === 'succeeded') {
                            downloadPromises.push(
                                API.hdDownload({ taskId: item.taskId })
                                    .then(res => {
                                        if (res?.code != 0) {
                                            removeTaskFromListCallback(item.taskId)
                                            throw new Error(res?.message)
                                        }
                                        const image = res.data
                                        Utils.downUrl(image, item.imageType)
                                        message.success('下载成功')
                                        // 从HDCurrentList中移除已下载taskId
                                        removeTaskFromListCallback(item.taskId)
                                    })
                                    .catch(err => {
                                        console.error(err)
                                        message.warning(err.message)
                                    })
                            )
                        } else if (result.hdStatus === 'failed') {
                            message.warning('高清失败！')
                            removeTaskFromListCallback(item.taskId)
                        }
                    })
                }
            })

            await Promise.all(downloadPromises)
        }
    } catch (err) {
        console.error(err)
        message.warning(err.message)
        return false
    }
}

// 高清预览
export const doHDPreview = async (taskId, imageType, callback) => {
    const list = [taskId]
    const HDres = await API.doHDv2({ taskId: taskId, imageType: imageType })
    if (HDres?.code != 0) throw new Error(HDres?.message)
    callback()
}

export default {
    generateDisabled,
    workflowOfLoadTaskInfo,
    workflowOfSendTask,
    workflowOfGenerate,
    workflowOfReGenerate,
    workflowOfChange,
    queryHDStatusv2,
    doHDPreview,
}
